import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable sonarjs/no-duplicate-string */
import { PhoneIcon } from '@gemini/icons';
import { Link } from '@gemini/ui';
import Trans from '@/components/tools/Trans';
import { createBrand } from '../factory';
import { Layout } from './Layout';
const linkBox = [
    {
        order: '1',
        type: 'SiteMap',
        links: [
            {
                url: 'https://www.immowelt.de/anbieten/wohnung-vermieten',
                label: 'Wohnung vermieten',
                title: 'Wohnung vermieten',
            },
            {
                url: 'https://www.immowelt.de/anbieten/wohnung-verkaufen',
                label: 'Wohnung verkaufen',
                title: 'Wohnung verkaufen',
            },
            {
                url: 'https://www.immowelt.de/anbieten/haus-vermieten',
                label: 'Haus vermieten',
                title: 'Haus vermieten',
            },
            {
                url: 'https://www.immowelt.de/anbieten/haus-verkaufen',
                label: 'Haus verkaufen',
                title: 'Haus verkaufen',
            },
            {
                url: 'https://www.immowelt.de/anbieten/grundstueck-verkaufen',
                label: 'Grundstück verkaufen',
                title: 'Grundstück verkaufen',
            },
            {
                url: 'https://www.immowelt.de/anbieten/grundstueck-verpachten',
                label: 'Grundstück verpachten',
                title: 'Grundstück verpachten',
            },
            {
                url: 'https://www.immowelt.de/anbieten/buero-vermieten',
                label: 'Büro vermieten',
                title: 'Büro vermieten',
            },
            {
                url: 'https://www.immowelt.de/anbieten/immobilien-vermieten',
                label: 'Immobilien vermieten',
                title: 'Immobilien vermieten',
            },
            {
                url: 'https://www.immowelt.de/anbieten/immobilien-verkaufen',
                label: 'Immobilienverkauf',
                title: 'Immobilienverkauf',
            },
            {
                url: 'https://www.immowelt.de/anbieten/nachmieter',
                label: 'Nachmieter suchen',
                title: 'Nachmieter suchen',
            },
            {
                url: 'https://www.immowelt.de/anbieten/gewerbeimmobilien',
                label: 'Gewerbeimmobilien',
                title: 'Gewerbeimmobilien',
            },
            {
                url: 'https://www.immowelt.de/anbieten/wohnung-inserieren',
                label: 'Wohnung inserieren',
                title: 'Wohnung inserieren',
            },
        ],
    },
];
export default createBrand({
    brand: 'immowelt',
    shortBrand: 'IWT',
    prefixI18n: '',
    template: Layout,
    routes: {
        fsrbo: {
            generic: 'anbieten/immobilienanzeigen',
            flats: 'anbieten/wohnung-inserieren',
            commercialProperties: 'anbieten/gewerbeimmobilien',
        },
        fsbo: {
            plots: 'anbieten/grundstueck-verkaufen',
            generic: 'anbieten/immobilien-verkaufen',
        },
        frbo: {
            generic: 'anbieten/immobilien-vermieten',
            flats: 'anbieten/wohnung-vermieten',
            houses: 'anbieten/haus-vermieten',
            plots: 'anbieten/grundstueck-verpachten',
            commercialProperties: 'anbieten/buero-vermieten',
        },
    },
    common: {
        popin: {
            urlPro: 'https://signin.immowelt.de/?path=%2Fdispatcher%2Findex.html%3Fm%3Dclassified_deposit_project_project_list_your_dedicated_service_general_caf_step_1&m=classified_deposit_project_project_list_your_dedicated_service_general_caf_step_1',
            imgUserType: {
                private: `${process.env.STATIC_ASSETS_PATH}/images/5f3d94f1-fc07-43df-b1fe-09c4b1d9d1d1.svg`,
                pro: `${process.env.STATIC_ASSETS_PATH}/images/0f4af85d-d2e3-4c9b-bd0b-9670a295e672.svg`,
            },
            imgDistributionType: {
                rent: `${process.env.STATIC_ASSETS_PATH}/images/4b68572d-e871-4cca-9c9d-f5748ff60012.svg`,
                sale: `${process.env.STATIC_ASSETS_PATH}/images/d4636e7e-a8fc-405f-8121-08ba567a9291.svg`,
            },
        },
    },
    pages: {
        fsrbo: {
            generic: {
                popin: {
                    url: {
                        rent: '/eigentuemer/anzeigenerfassung/privatvermietung',
                        sale: '/eigentuemer/anzeigenerfassung/privatverkauf',
                    },
                },
                breadcrumb: {
                    data: {
                        order: '0',
                        type: 'Breadcrumb',
                        name: 'dflp-generic-breadcrumb',
                        title: 'dflp-generic-breadcrumb',
                        slug: 'dflp-generic-breadcrumb',
                        links: [
                            {
                                url: '/',
                                label: 'immowelt',
                                title: 'immowelt',
                            },
                            {
                                url: '/anbieten',
                                label: 'Anbieten',
                                title: 'Anbieten',
                            },
                            {
                                url: '',
                                label: 'Immobilienanzeigen',
                                title: 'Immobilienanzeigen',
                            },
                        ],
                    },
                },
                hero: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/874dde32-393c-4568-a053-a386596f447a.webp`,
                    imgMobile: `${process.env.STATIC_ASSETS_PATH}/images/b1482286-e6ca-4b90-8c62-7a2d93e1f89f.webp`,
                    listItems: [
                        {
                            id: 'fsrbo.generic.hero.list.item1',
                            text: 'fsrbo.generic.hero.list.item1',
                        },
                        {
                            id: 'fsrbo.generic.hero.list.item2',
                            text: 'fsrbo.generic.hero.list.item2',
                        },
                        {
                            id: 'fsrbo.generic.hero.list.item3',
                            text: 'fsrbo.generic.hero.list.item3',
                        },
                    ],
                },
                valueProposition: [
                    {
                        title: 'fsrbo.generic.valueprop.list.item1.title',
                        text: 'fsrbo.generic.valueprop.list.item1.text',
                        id: 'known',
                    },
                    {
                        title: 'fsrbo.generic.valueprop.list.item2.title',
                        text: 'fsrbo.generic.valueprop.list.item2.text',
                        id: 'listings',
                    },
                    {
                        title: 'fsrbo.generic.valueprop.list.item3.title',
                        text: 'fsrbo.generic.valueprop.list.item3.text',
                        id: 'experience',
                    },
                ],
                callToAction: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6420fdaa-b8f7-4b49-8f56-3c1cef6878a9.svg`,
                },
                pricing: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6eb37fd3-fec4-4af6-9a40-a74766f7be5f.webp`,
                },
                offerSelection: {
                    isOfferSelectionDisplayed: true,
                    products: [
                        {
                            id: 'good',
                            name: 'offerCard.good.title',
                            description: 'offerCard.good.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/116ddba9-5ac7-4ea9-b6d9-862253abee9e.svg`,
                            iconAlt: 'offerCard.good.iconAlt',
                            featuresTitle: 'offerCard.good.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.good.features.item1',
                                },
                                {
                                    description: 'offerCard.good.features.item2',
                                },
                            ],
                        },
                        {
                            id: 'better',
                            name: 'offerCard.better.title',
                            description: 'offerCard.better.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/f91cf35f-00ba-42ad-8200-dcc7b11d2a33.svg`,
                            iconAlt: 'offerCard.better.iconAlt',
                            featuresTitle: 'offerCard.better.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.better.features.item1',
                                },
                                {
                                    description: 'offerCard.better.features.item2',
                                },
                            ],
                            isMostPopular: true,
                        },
                        {
                            id: 'best',
                            name: 'offerCard.best.title',
                            description: 'offerCard.best.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/523b043b-58f4-48a0-b9cf-76ca3b58a5bc.svg`,
                            iconAlt: 'offerCard.best.iconAlt',
                            featuresTitle: 'offerCard.best.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.best.features.item1',
                                },
                                {
                                    description: 'offerCard.best.features.item2',
                                },
                            ],
                        },
                    ],
                    offers: [
                        {
                            name: 'RENT',
                            label: 'offerCard.rent.label',
                            transactionType: 'RENT',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 0,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 34.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 54.99,
                                },
                            ],
                            default: true,
                        },
                        {
                            name: 'BUY',
                            label: 'offerCard.buy.label',
                            transactionType: 'BUY',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 59.99,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 84.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 139.99,
                                },
                            ],
                        },
                    ],
                },
                pushCards: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/451a3782-7530-4c27-a01e-fd235ffe9ce0.webp`,
                            url: '/immobilienpreise/deutschland',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0e810d8b-ba68-477b-824a-d8d92ae717d7.webp`,
                            url: 'https://signin.immowelt.de/?path=%2Fdispatcher%2Findex.html%3Fm%3Dclassified_deposit_project_project_list_your_dedicated_service_general_caf_step_1&m=classified_deposit_landing_access_the_service_general_caf_step_1 ',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e924fb03-cdc7-45f2-9d15-a6f61b42955e.webp`,
                            url: '/immobilienbewertung',
                        },
                    ],
                },
                edito: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e89acf70-8c29-48c8-8b9f-15db43e99d59.webp`,
                            url: 'https://www.immowelt.de/ratgeber/mieten/untervermietung-vertrag',
                            description: 'fsrbo.generic.edito.list.item1.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0c8f445c-f949-4533-bcef-bd714b73c2f5.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/vermietung-moebliert',
                            description: 'fsrbo.generic.edito.list.item2.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f48cbde-9790-4207-ae31-b980d55932f1.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-privat-verkaufen',
                            description: 'fsrbo.generic.edito.list.item3.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/176ba009-95f7-44fe-97d7-00805c20a98e.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/geerbtes-haus-verkaufen',
                            description: 'fsrbo.generic.edito.list.item4.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/ee95f773-fb23-451d-b8cc-41e6ad49a504.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/wertsteigerung-immobilien',
                            description: 'fsrbo.generic.edito.list.item5.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0f740b6b-74cf-424e-b2e7-0c2a60427307.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/nach-eigenbedarf-wieder-vermieten',
                            description: 'fsrbo.generic.edito.list.item6.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/661ef596-aae1-4f63-a756-8b95751dcf90.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/vermietete-wohnung-verkaufen',
                            description: 'fsrbo.generic.edito.list.item7.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/13ea3267-daa3-4c81-9086-7842d55596f8.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/expose-erstellen',
                            description: 'fsrbo.generic.edito.list.item8.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f4cdd17-71c6-4842-96c3-8ad5931d50bf.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-verkaufen-wohnrecht',
                            description: 'fsrbo.generic.edito.list.item9.text',
                            visible: true,
                        },
                    ],
                },
                realEstateListing: {
                    color: 'color.border.active.default',
                    dashLine: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/43ab276d-558a-4210-87c6-a592142b6fd9.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/87ec661c-959d-4884-9af6-064ecd2436ae.webp`,
                    },
                    items: [
                        {
                            illustration: `${process.env.STATIC_ASSETS_PATH}/images/b55b4fd2-3cac-4d8c-a049-a50f01e8f977.webp`,
                            number: {
                                desktop: `${process.env.STATIC_ASSETS_PATH}/images/d14ffb5a-76e3-4289-9bcd-c58ce6dd6ebf.webp`,
                                mobile: `${process.env.STATIC_ASSETS_PATH}/images/327ccbb8-bed3-4fa1-a733-e3ebffb05b83.webp`,
                            },
                            description: (_jsx(Trans, { translation: `fsrbo.generic.realestate.list.item1.text_copy`, components: {
                                    link1: (_jsx(Link, { href: "/immobilienbewertung", variant: "inline", children: "children" })),
                                    link2: (_jsx(Link, { href: "/mietpreisrechner", variant: "inline", children: "children" })),
                                    strong: _jsx("strong", {}),
                                } })),
                        },
                        {
                            illustration: `${process.env.STATIC_ASSETS_PATH}/images/410d28ea-c26a-4634-9644-1b4fbc39d179.webp`,
                            number: {
                                desktop: `${process.env.STATIC_ASSETS_PATH}/images/07db49cc-90ca-41bb-b443-1c4311e615c2.webp`,
                                mobile: `${process.env.STATIC_ASSETS_PATH}/images/f32fe485-c497-4cb2-aaa1-bdc1c871321d.webp`,
                            },
                            description: (_jsx(Trans, { translation: `fsrbo.generic.realestate.list.item2.text`, components: {
                                    strong: _jsx("strong", {}),
                                } })),
                        },
                        {
                            illustration: `${process.env.STATIC_ASSETS_PATH}/images/a1b2886c-3507-4c3c-8d27-7104d4a7160e.webp`,
                            number: {
                                desktop: `${process.env.STATIC_ASSETS_PATH}/images/15a1f82f-af70-4aa2-b8df-ea5c5a9a164f.webp`,
                                mobile: `${process.env.STATIC_ASSETS_PATH}/images/7879b95f-c7b8-4f99-8217-baec49639f7e.webp`,
                            },
                            description: (_jsx(Trans, { translation: `fsrbo.generic.realestate.list.item3.text`, components: {
                                    strong: _jsx("strong", {}),
                                } })),
                        },
                        {
                            illustration: `${process.env.STATIC_ASSETS_PATH}/images/5b84eabf-8f02-4f88-98fe-3aeef5c6186b.webp`,
                            number: {
                                desktop: `${process.env.STATIC_ASSETS_PATH}/images/29ff74f9-bee3-4208-b85d-ca3d2a38396f.webp`,
                                mobile: `${process.env.STATIC_ASSETS_PATH}/images/6d178f36-32d3-4161-858c-51835bacf295.webp`,
                            },
                            description: (_jsx(Trans, { translation: `fsrbo.generic.realestate.list.item4.text_copy`, components: {
                                    link: (_jsx(Link, { href: "/anbieten/energieausweis", variant: "inline", children: "children" })),
                                    strong: _jsx("strong", {}),
                                } })),
                        },
                        {
                            illustration: `${process.env.STATIC_ASSETS_PATH}/images/55ba59f3-ff7f-47fd-a62c-125422dacf60.webp`,
                            number: {
                                desktop: `${process.env.STATIC_ASSETS_PATH}/images/2b898ed9-b246-452e-84c2-1383a05b385a.webp`,
                                mobile: `${process.env.STATIC_ASSETS_PATH}/images/1f31b2b3-a250-4562-8bc4-0712e84e7626.webp`,
                            },
                            description: (_jsx(Trans, { translation: `fsrbo.generic.realestate.list.item5.text`, components: {
                                    strong: _jsx("strong", {}),
                                } })),
                        },
                    ],
                },
                faq: {
                    title: 'iwt.fsrbo.generic.faq.title',
                    items: [
                        {
                            title: 'iwt.fsrbo.generic.faq.list.item1.title',
                            text: 'iwt.fsrbo.generic.faq.list.item1.text',
                        },
                        {
                            title: 'iwt.fsrbo.generic.faq.list.item2.title',
                            text: 'iwt.fsrbo.generic.faq.list.item2.text',
                        },
                        {
                            title: 'iwt.fsrbo.generic.faq.list.item2.title',
                            text: 'iwt.fsrbo.generic.faq.list.item2.text',
                        },
                        {
                            title: 'iwt.fsrbo.generic.faq.list.item3.title',
                            text: 'iwt.fsrbo.generic.faq.list.item3.text',
                        },
                        {
                            title: 'iwt.fsrbo.generic.faq.list.item4.title',
                            text: 'iwt.fsrbo.generic.faq.list.item4.text',
                        },
                        {
                            title: 'iwt.fsrbo.generic.faq.list.item5.title',
                            text: 'iwt.fsrbo.generic.faq.list.item5.text',
                        },
                        {
                            title: 'iwt.fsrbo.generic.faq.list.item6.title',
                            text: (_jsx(Trans, { translation: "iwt.fsrbo.generic.faq.list.item6.text", components: {
                                    link: (_jsx(Link, { href: "https://www.immowelt.de/", variant: "inline", children: "children" })),
                                } })),
                        },
                    ],
                },
                contact: {
                    textLeft: false,
                    img: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/1e6fdba4-ae43-4668-8fed-2c3032960173.webp`,
                        tablet: `${process.env.STATIC_ASSETS_PATH}/images/585d1782-84f3-4e16-84d7-a485aa334b23.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.webp`,
                    },
                    cta: 'https://support.immowelt.de/hilfekontakt',
                    items: [
                        {
                            content: '+49 911 520 25-0',
                            icon: PhoneIcon,
                        },
                    ],
                },
                linkBox,
            },
            flats: {
                popin: {
                    url: {
                        rent: '/eigentuemer/anzeigenerfassung/privatvermietung?propertyType=apartment',
                        sale: '/eigentuemer/anzeigenerfassung/privatverkauf?propertyType=apartment',
                    },
                },
                breadcrumb: {
                    data: {
                        order: '0',
                        type: 'Breadcrumb',
                        name: 'dflp-flats-breadcrumb',
                        title: 'dflp-flats-breadcrumb',
                        slug: 'dflp-flats-breadcrumb',
                        links: [
                            {
                                url: '/',
                                label: 'immowelt',
                                title: 'immowelt',
                            },
                            {
                                url: '/anbieten',
                                label: 'Anbieten',
                                title: 'Anbieten',
                            },
                            {
                                url: '',
                                label: 'Wohnung-inserieren',
                                title: 'Wohnung-inserieren',
                            },
                        ],
                    },
                },
                hero: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/874dde32-393c-4568-a053-a386596f447a.webp`,
                    imgMobile: `${process.env.STATIC_ASSETS_PATH}/images/b1482286-e6ca-4b90-8c62-7a2d93e1f89f.webp`,
                    listItems: [
                        {
                            id: 'fsrbo.flats.hero.list.item1',
                            text: 'fsrbo.flats.hero.list.item1',
                        },
                        {
                            id: 'fsrbo.flats.hero.list.item2',
                            text: 'fsrbo.flats.hero.list.item2',
                        },
                        {
                            id: 'fsrbo.flats.hero.list.item3',
                            text: 'fsrbo.flats.hero.list.item3',
                        },
                    ],
                },
                valueProposition: [
                    {
                        title: 'fsrbo.flats.valueprop.list.item1.title',
                        text: 'fsrbo.flats.valueprop.list.item1.text',
                        id: 'known',
                    },
                    {
                        title: 'fsrbo.flats.valueprop.list.item2.title',
                        text: 'fsrbo.flats.valueprop.list.item2.text',
                        id: 'listings',
                    },
                    {
                        title: 'fsrbo.flats.valueprop.list.item3.title',
                        text: 'fsrbo.flats.valueprop.list.item3.text',
                        id: 'experience',
                    },
                ],
                callToAction: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6420fdaa-b8f7-4b49-8f56-3c1cef6878a9.svg`,
                },
                pricing: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6eb37fd3-fec4-4af6-9a40-a74766f7be5f.webp`,
                },
                offerSelection: {
                    isOfferSelectionDisplayed: true,
                    products: [
                        {
                            id: 'good',
                            name: 'offerCard.good.title',
                            description: 'offerCard.good.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/116ddba9-5ac7-4ea9-b6d9-862253abee9e.svg`,
                            iconAlt: 'offerCard.good.iconAlt',
                            featuresTitle: 'offerCard.good.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.good.features.item1',
                                },
                                {
                                    description: 'offerCard.good.features.item2',
                                },
                            ],
                        },
                        {
                            id: 'better',
                            name: 'offerCard.better.title',
                            description: 'offerCard.better.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/f91cf35f-00ba-42ad-8200-dcc7b11d2a33.svg`,
                            iconAlt: 'offerCard.better.iconAlt',
                            featuresTitle: 'offerCard.better.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.better.features.item1',
                                },
                                {
                                    description: 'offerCard.better.features.item2',
                                },
                            ],
                            isMostPopular: true,
                        },
                        {
                            id: 'best',
                            name: 'offerCard.best.title',
                            description: 'offerCard.best.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/523b043b-58f4-48a0-b9cf-76ca3b58a5bc.svg`,
                            iconAlt: 'offerCard.best.iconAlt',
                            featuresTitle: 'offerCard.best.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.best.features.item1',
                                },
                                {
                                    description: 'offerCard.best.features.item2',
                                },
                            ],
                        },
                    ],
                    offers: [
                        {
                            name: 'RENT',
                            label: 'offerCard.rent.label',
                            transactionType: 'RENT',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 0,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 34.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 54.99,
                                },
                            ],
                            default: true,
                        },
                        {
                            name: 'BUY',
                            label: 'offerCard.buy.label',
                            transactionType: 'BUY',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 59.99,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 84.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 139.99,
                                },
                            ],
                        },
                    ],
                },
                pushCards: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/451a3782-7530-4c27-a01e-fd235ffe9ce0.webp`,
                            url: '/immobilienpreise/deutschland',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0e810d8b-ba68-477b-824a-d8d92ae717d7.webp`,
                            url: 'https://signin.immowelt.de/?path=%2Fdispatcher%2Findex.html%3Fm%3Dclassified_deposit_project_project_list_your_dedicated_service_general_caf_step_1&m=classified_deposit_landing_access_the_service_general_caf_step_1 ',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e924fb03-cdc7-45f2-9d15-a6f61b42955e.webp`,
                            url: '/immobilienbewertung',
                        },
                    ],
                },
                edito: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e89acf70-8c29-48c8-8b9f-15db43e99d59.webp`,
                            url: 'https://www.immowelt.de/ratgeber/mieten/untervermietung-vertrag',
                            description: 'fsrbo.generic.edito.list.item1.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0c8f445c-f949-4533-bcef-bd714b73c2f5.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/vermietung-moebliert',
                            description: 'fsrbo.generic.edito.list.item2.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f48cbde-9790-4207-ae31-b980d55932f1.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-privat-verkaufen',
                            description: 'fsrbo.generic.edito.list.item3.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/176ba009-95f7-44fe-97d7-00805c20a98e.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/geerbtes-haus-verkaufen',
                            description: 'fsrbo.generic.edito.list.item4.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/ee95f773-fb23-451d-b8cc-41e6ad49a504.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/wertsteigerung-immobilien',
                            description: 'fsrbo.generic.edito.list.item5.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0f740b6b-74cf-424e-b2e7-0c2a60427307.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/nach-eigenbedarf-wieder-vermieten',
                            description: 'fsrbo.generic.edito.list.item6.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/661ef596-aae1-4f63-a756-8b95751dcf90.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/vermietete-wohnung-verkaufen',
                            description: 'fsrbo.generic.edito.list.item8.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/13ea3267-daa3-4c81-9086-7842d55596f8.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/expose-erstellen',
                            description: 'fsrbo.generic.edito.list.item9.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f4cdd17-71c6-4842-96c3-8ad5931d50bf.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-verkaufen-wohnrecht',
                            description: 'fsrbo.generic.edito.list.item10.text',
                            visible: true,
                        },
                    ],
                },
                contact: {
                    textLeft: false,
                    img: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/1e6fdba4-ae43-4668-8fed-2c3032960173.webp`,
                        tablet: `${process.env.STATIC_ASSETS_PATH}/images/585d1782-84f3-4e16-84d7-a485aa334b23.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.webp`,
                    },
                    cta: 'https://support.immowelt.de/hilfekontakt',
                    items: [
                        {
                            content: '+49 911 520 25-0',
                            icon: PhoneIcon,
                        },
                    ],
                },
                advertising: {
                    sections: [
                        {
                            id: 'tips',
                            title: 'fsrbo.flats.advertising.tips.title',
                            text: [
                                'fsrbo.flats.advertising.tips.text.part1',
                                'fsrbo.flats.advertising.tips.text.part2',
                            ],
                            feedback: 'fsrbo.flats.advertising.tips.feedbackmessage',
                        },
                        {
                            id: 'pictures',
                            title: 'fsrbo.flats.advertising.pictures.title',
                            text: [
                                'fsrbo.flats.advertising.pictures.text.part1',
                                'fsrbo.flats.advertising.pictures.text.part2',
                            ],
                        },
                        {
                            id: 'writing',
                            title: 'fsrbo.flats.advertising.writing.title',
                            text: [
                                'fsrbo.flats.advertising.writing.text.part1',
                                'fsrbo.flats.advertising.writing.text.part2',
                            ],
                            list: [
                                'fsrbo.flats.advertising.writing.list.part1',
                                'fsrbo.flats.advertising.writing.list.part2',
                                'fsrbo.flats.advertising.writing.list.part3',
                                'fsrbo.flats.advertising.writing.list.part4',
                                'fsrbo.flats.advertising.writing.list.part5',
                                'fsrbo.flats.advertising.writing.list.part6',
                                'fsrbo.flats.advertising.writing.list.part7',
                                'fsrbo.flats.advertising.writing.list.part8',
                                'fsrbo.flats.advertising.writing.list.part9',
                                'fsrbo.flats.advertising.writing.list.part10',
                            ],
                            certificate: {
                                img: `${process.env.STATIC_ASSETS_PATH}/images/a57f6933-3f2e-444e-8641-b8306d7b4fb7.webp`,
                                title: 'fsrbo.flats.advertising.writing.certificate.title',
                                text: 'fsrbo.flats.advertising.writing.certificate.text',
                                cta: 'fsrbo.flats.advertising.writing.certificate.cta',
                            },
                            feedback: 'fsrbo.flats.advertising.writing.feedbackmessage',
                        },
                        {
                            id: 'advantages',
                            title: 'fsrbo.flats.advertising.advantages.title',
                            text: [
                                'fsrbo.flats.advertising.advantages.text.part1',
                                'fsrbo.flats.advertising.advantages.text.part2',
                                'fsrbo.flats.advertising.advantages.text.part3',
                            ],
                        },
                    ],
                    cta: 'https://www.immowelt.de/anbieten/energieausweis?m=owner_page_sell_energy_certificate_order_energy_certificate',
                },
                linkBox,
            },
            commercial: {
                popin: {
                    url: {
                        rent: '/eigentuemer/anzeigenerfassung/privatvermietung?propertyType=office',
                        sale: '/eigentuemer/anzeigenerfassung/privatverkauf?propertyType=office',
                    },
                },
                breadcrumb: {
                    data: {
                        order: '0',
                        type: 'Breadcrumb',
                        name: 'dflp-commercial-breadcrumb',
                        title: 'dflp-commercial-breadcrumb',
                        slug: 'dflp-commercial-breadcrumb',
                        links: [
                            {
                                url: '/',
                                label: 'immowelt',
                                title: 'immowelt',
                            },
                            {
                                url: '/anbieten',
                                label: 'Anbieten',
                                title: 'Anbieten',
                            },
                            {
                                url: '',
                                label: 'Gewerbeimmobilien verkaufen oder vermieten',
                                title: 'Gewerbeimmobilien verkaufen oder vermieten',
                            },
                        ],
                    },
                },
                hero: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/874dde32-393c-4568-a053-a386596f447a.webp`,
                    imgMobile: `${process.env.STATIC_ASSETS_PATH}/images/b1482286-e6ca-4b90-8c62-7a2d93e1f89f.webp`,
                    listItems: [
                        {
                            id: 'fsrbo.generic.hero.list.item1',
                            text: 'fsrbo.generic.hero.list.item1',
                        },
                        {
                            id: 'fsrbo.generic.hero.list.item2',
                            text: 'fsrbo.generic.hero.list.item2',
                        },
                        {
                            id: 'fsrbo.generic.hero.list.item3',
                            text: 'fsrbo.generic.hero.list.item3',
                        },
                    ],
                },
                valueProposition: [
                    {
                        title: 'fsrbo.generic.valueprop.list.item1.title',
                        text: 'fsrbo.generic.valueprop.list.item1.text',
                        id: 'known',
                    },
                    {
                        title: 'fsrbo.generic.valueprop.list.item2.title',
                        text: 'fsrbo.generic.valueprop.list.item2.text',
                        id: 'listings',
                    },
                    {
                        title: 'fsrbo.generic.valueprop.list.item3.title',
                        text: 'fsrbo.generic.valueprop.list.item3.text',
                        id: 'experience',
                    },
                ],
                callToAction: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6420fdaa-b8f7-4b49-8f56-3c1cef6878a9.svg`,
                },
                pricing: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6eb37fd3-fec4-4af6-9a40-a74766f7be5f.webp`,
                },
                offerSelection: {
                    isOfferSelectionDisplayed: true,
                    products: [
                        {
                            id: 'good',
                            name: 'offerCard.good.title',
                            description: 'offerCard.good.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/116ddba9-5ac7-4ea9-b6d9-862253abee9e.svg`,
                            iconAlt: 'offerCard.good.iconAlt',
                            featuresTitle: 'offerCard.good.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.good.features.item1',
                                },
                                {
                                    description: 'offerCard.good.features.item2',
                                },
                            ],
                        },
                        {
                            id: 'better',
                            name: 'offerCard.better.title',
                            description: 'offerCard.better.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/f91cf35f-00ba-42ad-8200-dcc7b11d2a33.svg`,
                            iconAlt: 'offerCard.better.iconAlt',
                            featuresTitle: 'offerCard.better.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.better.features.item1',
                                },
                                {
                                    description: 'offerCard.better.features.item2',
                                },
                            ],
                            isMostPopular: true,
                        },
                        {
                            id: 'best',
                            name: 'offerCard.best.title',
                            description: 'offerCard.best.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/523b043b-58f4-48a0-b9cf-76ca3b58a5bc.svg`,
                            iconAlt: 'offerCard.best.iconAlt',
                            featuresTitle: 'offerCard.best.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.best.features.item1',
                                },
                                {
                                    description: 'offerCard.best.features.item2',
                                },
                            ],
                        },
                    ],
                    offers: [
                        {
                            name: 'RENT',
                            label: 'offerCard.rent.label',
                            transactionType: 'RENT',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 0,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 34.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 54.99,
                                },
                            ],
                            default: true,
                        },
                        {
                            name: 'BUY',
                            label: 'offerCard.buy.label',
                            transactionType: 'BUY',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 59.99,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 84.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 139.99,
                                },
                            ],
                        },
                    ],
                },
                pushCards: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/451a3782-7530-4c27-a01e-fd235ffe9ce0.webp`,
                            url: '/immobilienpreise/deutschland',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0e810d8b-ba68-477b-824a-d8d92ae717d7.webp`,
                            url: 'https://signin.immowelt.de/?path=%2Fdispatcher%2Findex.html%3Fm%3Dclassified_deposit_project_project_list_your_dedicated_service_general_caf_step_1&m=classified_deposit_landing_access_the_service_general_caf_step_1 ',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e924fb03-cdc7-45f2-9d15-a6f61b42955e.webp`,
                            url: '/immobilienbewertung',
                        },
                    ],
                },
                edito: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e89acf70-8c29-48c8-8b9f-15db43e99d59.webp`,
                            url: 'https://www.immowelt.de/ratgeber/mieten/untervermietung-vertrag',
                            description: 'fsrbo.generic.edito.list.item1.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0c8f445c-f949-4533-bcef-bd714b73c2f5.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/vermietung-moebliert',
                            description: 'fsrbo.generic.edito.list.item2.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f48cbde-9790-4207-ae31-b980d55932f1.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-privat-verkaufen',
                            description: 'fsrbo.generic.edito.list.item3.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/176ba009-95f7-44fe-97d7-00805c20a98e.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/geerbtes-haus-verkaufen',
                            description: 'fsrbo.generic.edito.list.item4.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/ee95f773-fb23-451d-b8cc-41e6ad49a504.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/wertsteigerung-immobilien',
                            description: 'fsrbo.generic.edito.list.item5.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0f740b6b-74cf-424e-b2e7-0c2a60427307.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/nach-eigenbedarf-wieder-vermieten',
                            description: 'fsrbo.generic.edito.list.item6.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/661ef596-aae1-4f63-a756-8b95751dcf90.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/vermietete-wohnung-verkaufen',
                            description: 'fsrbo.generic.edito.list.item8.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/13ea3267-daa3-4c81-9086-7842d55596f8.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/expose-erstellen',
                            description: 'fsrbo.generic.edito.list.item9.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f4cdd17-71c6-4842-96c3-8ad5931d50bf.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-verkaufen-wohnrecht',
                            description: 'fsrbo.generic.edito.list.item10.text',
                            visible: true,
                        },
                    ],
                },
                advertising: {
                    sections: [
                        {
                            id: 'tips',
                            title: 'fsrbo.commercial.advertising.tips.title',
                            text: ['fsrbo.commercial.advertising.tips.text.part1'],
                        },
                        {
                            id: 'types',
                            title: 'fsrbo.commercial.advertising.types.title',
                            text: ['fsrbo.commercial.advertising.types.text.part1'],
                            list: [
                                'fsrbo.commercial.advertising.types.list.part1',
                                'fsrbo.commercial.advertising.types.list.part2',
                                'fsrbo.commercial.advertising.types.list.part3',
                                'fsrbo.commercial.advertising.types.list.part4',
                                'fsrbo.commercial.advertising.types.list.part5',
                                'fsrbo.commercial.advertising.types.list.part6',
                            ],
                        },
                        {
                            id: 'how',
                            title: 'fsrbo.commercial.advertising.how.title',
                            text: ['fsrbo.commercial.advertising.how.text.part1'],
                            orderedList: [
                                'fsrbo.commercial.advertising.how.list.part1',
                                'fsrbo.commercial.advertising.how.list.part2',
                                [
                                    'fsrbo.commercial.advertising.how.list.part2.subpart1',
                                    'fsrbo.commercial.advertising.how.list.part2.subpart2',
                                    'fsrbo.commercial.advertising.how.list.part2.subpart3',
                                    'fsrbo.commercial.advertising.how.list.part2.subpart4',
                                ],
                                'fsrbo.commercial.advertising.how.list.part3',
                                'fsrbo.commercial.advertising.how.list.part4',
                            ],
                        },
                        {
                            id: 'works',
                            title: 'fsrbo.commercial.advertising.works.title',
                            text: [
                                _jsx(Trans, { translation: "fsrbo.commercial.advertising.works.text.part1", components: {
                                        link: (_jsx(Link, { href: "/anbieten/buero-vermieten", variant: "inline", children: "children" })),
                                    } }),
                            ],
                        },
                    ],
                },
                contact: {
                    textLeft: false,
                    img: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/1e6fdba4-ae43-4668-8fed-2c3032960173.webp`,
                        tablet: `${process.env.STATIC_ASSETS_PATH}/images/585d1782-84f3-4e16-84d7-a485aa334b23.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.webp`,
                    },
                    cta: 'https://support.immowelt.de/hilfekontakt',
                    items: [
                        {
                            content: '+49 911 520 25-0',
                            icon: PhoneIcon,
                        },
                    ],
                },
                linkBox,
            },
        },
        frbo: {
            generic: {
                popin: {
                    url: {
                        rent: '/eigentuemer/anzeigenerfassung/privatvermietung',
                        sale: '',
                    },
                },
                breadcrumb: {
                    data: {
                        order: '0',
                        type: 'Breadcrumb',
                        name: 'dflp-flats-breadcrumb',
                        title: 'dflp-flats-breadcrumb',
                        slug: 'dflp-flats-breadcrumb',
                        links: [
                            {
                                url: '/',
                                label: 'immowelt',
                                title: 'immowelt',
                            },
                            {
                                url: '/anbieten',
                                label: 'Anbieten',
                                title: 'Anbieten',
                            },
                            {
                                url: '',
                                label: 'Immobilien vermieten',
                                title: 'Immobilien vermieten',
                            },
                        ],
                    },
                },
                hero: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/874dde32-393c-4568-a053-a386596f447a.webp`,
                    imgMobile: `${process.env.STATIC_ASSETS_PATH}/images/b1482286-e6ca-4b90-8c62-7a2d93e1f89f.webp`,
                    listItems: [
                        {
                            id: 'frbo.generic.hero.list.item1',
                            text: 'frbo.generic.hero.list.item1',
                        },
                        {
                            id: 'frbo.generic.hero.list.item2',
                            text: 'frbo.generic.hero.list.item2',
                        },
                        {
                            id: 'frbo.generic.hero.list.item3',
                            text: 'frbo.generic.hero.list.item3',
                        },
                    ],
                },
                valueProposition: [
                    {
                        title: 'frbo.generic.valueprop.list.item1.title',
                        text: 'frbo.generic.valueprop.list.item1.text',
                        id: 'known',
                    },
                    {
                        title: 'frbo.generic.valueprop.list.item2.title',
                        text: 'frbo.generic.valueprop.list.item2.text',
                        id: 'listings',
                    },
                    {
                        title: 'frbo.generic.valueprop.list.item3.title',
                        text: 'frbo.generic.valueprop.list.item3.text',
                        id: 'experience',
                    },
                ],
                callToAction: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6420fdaa-b8f7-4b49-8f56-3c1cef6878a9.svg`,
                },
                pricing: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6eb37fd3-fec4-4af6-9a40-a74766f7be5f.webp`,
                },
                offerSelection: {
                    isOfferSelectionDisplayed: true,
                    products: [
                        {
                            id: 'good',
                            name: 'offerCard.good.title',
                            description: 'offerCard.good.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/116ddba9-5ac7-4ea9-b6d9-862253abee9e.svg`,
                            iconAlt: 'offerCard.good.iconAlt',
                            featuresTitle: 'offerCard.good.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.good.features.item1',
                                },
                                {
                                    description: 'offerCard.good.features.item2',
                                },
                            ],
                        },
                        {
                            id: 'better',
                            name: 'offerCard.better.title',
                            description: 'offerCard.better.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/f91cf35f-00ba-42ad-8200-dcc7b11d2a33.svg`,
                            iconAlt: 'offerCard.better.iconAlt',
                            featuresTitle: 'offerCard.better.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.better.features.item1',
                                },
                                {
                                    description: 'offerCard.better.features.item2',
                                },
                            ],
                            isMostPopular: true,
                        },
                        {
                            id: 'best',
                            name: 'offerCard.best.title',
                            description: 'offerCard.best.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/523b043b-58f4-48a0-b9cf-76ca3b58a5bc.svg`,
                            iconAlt: 'offerCard.best.iconAlt',
                            featuresTitle: 'offerCard.best.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.best.features.item1',
                                },
                                {
                                    description: 'offerCard.best.features.item2',
                                },
                            ],
                        },
                    ],
                    offers: [
                        {
                            name: 'RENT',
                            label: 'offerCard.rent.label',
                            transactionType: 'RENT',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 0,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 34.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 54.99,
                                },
                            ],
                            default: true,
                        },
                        {
                            name: 'BUY',
                            label: 'offerCard.buy.label',
                            transactionType: 'BUY',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 59.99,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 84.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 139.99,
                                },
                            ],
                        },
                    ],
                },
                pushCards: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/451a3782-7530-4c27-a01e-fd235ffe9ce0.webp`,
                            url: '/immobilienpreise/deutschland',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0e810d8b-ba68-477b-824a-d8d92ae717d7.webp`,
                            url: '/erfassung/immobilien/index.aspx?atype=business#basics',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e924fb03-cdc7-45f2-9d15-a6f61b42955e.webp`,
                            url: '/immobilienbewertung',
                        },
                    ],
                },
                edito: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e89acf70-8c29-48c8-8b9f-15db43e99d59.webp`,
                            url: 'https://www.immowelt.de/ratgeber/mieten/untervermietung-vertrag',
                            description: 'fsrbo.generic.edito.list.item1.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0c8f445c-f949-4533-bcef-bd714b73c2f5.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/vermietung-moebliert',
                            description: 'fsrbo.generic.edito.list.item2.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f48cbde-9790-4207-ae31-b980d55932f1.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-privat-verkaufen',
                            description: 'fsrbo.generic.edito.list.item3.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/176ba009-95f7-44fe-97d7-00805c20a98e.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/geerbtes-haus-verkaufen',
                            description: 'fsrbo.generic.edito.list.item4.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/ee95f773-fb23-451d-b8cc-41e6ad49a504.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/wertsteigerung-immobilien',
                            description: 'fsrbo.generic.edito.list.item5.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0f740b6b-74cf-424e-b2e7-0c2a60427307.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/nach-eigenbedarf-wieder-vermieten',
                            description: 'fsrbo.generic.edito.list.item6.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/661ef596-aae1-4f63-a756-8b95751dcf90.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/vermietete-wohnung-verkaufen',
                            description: 'fsrbo.generic.edito.list.item8.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/13ea3267-daa3-4c81-9086-7842d55596f8.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/expose-erstellen',
                            description: 'fsrbo.generic.edito.list.item9.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f4cdd17-71c6-4842-96c3-8ad5931d50bf.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-verkaufen-wohnrecht',
                            description: 'fsrbo.generic.edito.list.item10.text',
                            visible: true,
                        },
                    ],
                },
                contact: {
                    textLeft: false,
                    img: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/1e6fdba4-ae43-4668-8fed-2c3032960173.webp`,
                        tablet: `${process.env.STATIC_ASSETS_PATH}/images/585d1782-84f3-4e16-84d7-a485aa334b23.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.webp`,
                    },
                    cta: 'https://support.immowelt.de/hilfekontakt',
                    items: [
                        {
                            content: '+49 911 520 25-0',
                            icon: PhoneIcon,
                        },
                    ],
                },
                advertising: {
                    sections: [
                        {
                            id: 'rent',
                            title: 'frbo.generic.advertising.rent.title',
                            component: 'h2',
                            text: ['frbo.generic.advertising.rent.text1'],
                        },
                        {
                            id: 'marketing',
                            title: 'frbo.generic.advertising.marketing.title',
                            content: [
                                {
                                    text: ['frbo.generic.advertising.marketing.text1'],
                                    list: [
                                        'frbo.generic.advertising.marketing.list.item1',
                                        'frbo.generic.advertising.marketing.list.item2',
                                        'frbo.generic.advertising.marketing.list.item3',
                                        _jsx(Trans, { translation: "frbo.generic.advertising.marketing.list.item4", components: {
                                                link: (_jsx(Link, { href: "/anbieten/haus-vermieten", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                    textAfterList: ['frbo.generic.advertising.marketing.text2'],
                                },
                            ],
                        },
                        {
                            id: 'tenant',
                            title: 'frbo.generic.advertising.tenant.title',
                            text: [
                                _jsx(Trans, { translation: "frbo.generic.advertising.tenant.text1", components: {
                                        link: (_jsx(Link, { href: "/anbieten/wohnung-vermieten", variant: "inline", children: "children" })),
                                    } }),
                            ],
                        },
                        {
                            id: 'agreement',
                            title: 'frbo.generic.advertising.agreement.title',
                            text: [
                                _jsx(Trans, { translation: "frbo.generic.advertising.agreement.text1", components: {
                                        link: (_jsx(Link, { href: "/anbieten/mietvertrag-muster", variant: "inline", children: "children" })),
                                    } }),
                            ],
                        },
                    ],
                    cta: 'https://www.immowelt.de/anbieten/energieausweis?m=owner_page_sell_energy_certificate_order_energy_certificate',
                },
                linkBox,
            },
            flats: {
                popin: {
                    url: {
                        sale: '',
                        rent: '/eigentuemer/anzeigenerfassung/privatvermietung?propertyType=apartment',
                    },
                },
                breadcrumb: {
                    data: {
                        order: '0',
                        type: 'Breadcrumb',
                        name: 'dflp-flats-breadcrumb',
                        title: 'dflp-flats-breadcrumb',
                        slug: 'dflp-flats-breadcrumb',
                        links: [
                            {
                                url: '/',
                                label: 'immowelt',
                                title: 'immowelt',
                            },
                            {
                                url: '/anbieten',
                                label: 'Anbieten',
                                title: 'Anbieten',
                            },
                            {
                                url: '',
                                label: 'Wohnung-vermieten',
                                title: 'Wohnung-vermieten',
                            },
                        ],
                    },
                },
                hero: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/874dde32-393c-4568-a053-a386596f447a.webp`,
                    imgMobile: `${process.env.STATIC_ASSETS_PATH}/images/b1482286-e6ca-4b90-8c62-7a2d93e1f89f.webp`,
                    listItems: [
                        {
                            id: 'frbo.flats.hero.list.item1',
                            text: 'frbo.flats.hero.list.item1',
                        },
                        {
                            id: 'frbo.flats.hero.list.item2',
                            text: 'frbo.flats.hero.list.item2',
                        },
                        {
                            id: 'frbo.flats.hero.list.item3',
                            text: 'frbo.flats.hero.list.item3',
                        },
                    ],
                },
                valueProposition: [
                    {
                        title: 'frbo.flats.valueprop.list.item1.title',
                        text: 'frbo.flats.valueprop.list.item1.text',
                        id: 'known',
                    },
                    {
                        title: 'frbo.flats.valueprop.list.item2.title',
                        text: 'frbo.flats.valueprop.list.item2.text',
                        id: 'listings',
                    },
                    {
                        title: 'frbo.flats.valueprop.list.item3.title',
                        text: 'frbo.flats.valueprop.list.item3.text',
                        id: 'experience',
                    },
                ],
                callToAction: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6420fdaa-b8f7-4b49-8f56-3c1cef6878a9.svg`,
                },
                pricing: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6eb37fd3-fec4-4af6-9a40-a74766f7be5f.webp`,
                },
                offerSelection: {
                    isOfferSelectionDisplayed: true,
                    products: [
                        {
                            id: 'good',
                            name: 'offerCard.good.title',
                            description: 'offerCard.good.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/116ddba9-5ac7-4ea9-b6d9-862253abee9e.svg`,
                            iconAlt: 'offerCard.good.iconAlt',
                            featuresTitle: 'offerCard.good.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.good.features.item1',
                                },
                                {
                                    description: 'offerCard.good.features.item2',
                                },
                            ],
                        },
                        {
                            id: 'better',
                            name: 'offerCard.better.title',
                            description: 'offerCard.better.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/f91cf35f-00ba-42ad-8200-dcc7b11d2a33.svg`,
                            iconAlt: 'offerCard.better.iconAlt',
                            featuresTitle: 'offerCard.better.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.better.features.item1',
                                },
                                {
                                    description: 'offerCard.better.features.item2',
                                },
                            ],
                            isMostPopular: true,
                        },
                        {
                            id: 'best',
                            name: 'offerCard.best.title',
                            description: 'offerCard.best.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/523b043b-58f4-48a0-b9cf-76ca3b58a5bc.svg`,
                            iconAlt: 'offerCard.best.iconAlt',
                            featuresTitle: 'offerCard.best.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.best.features.item1',
                                },
                                {
                                    description: 'offerCard.best.features.item2',
                                },
                            ],
                        },
                    ],
                    offers: [
                        {
                            name: 'RENT',
                            label: 'offerCard.rent.label',
                            transactionType: 'RENT',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 0,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 34.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 54.99,
                                },
                            ],
                            default: true,
                        },
                        {
                            name: 'BUY',
                            label: 'offerCard.buy.label',
                            transactionType: 'BUY',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 59.99,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 84.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 139.99,
                                },
                            ],
                        },
                    ],
                },
                pushCards: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/451a3782-7530-4c27-a01e-fd235ffe9ce0.webp`,
                            url: '/immobilienpreise/deutschland',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0e810d8b-ba68-477b-824a-d8d92ae717d7.webp`,
                            url: 'https://signin.immowelt.de/?path=%2Fdispatcher%2Findex.html%3Fm%3Dclassified_deposit_project_project_list_your_dedicated_service_general_caf_step_1&m=classified_deposit_landing_access_the_service_general_caf_step_1 ',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e924fb03-cdc7-45f2-9d15-a6f61b42955e.webp`,
                            url: '/immobilienbewertung',
                        },
                    ],
                },
                edito: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e89acf70-8c29-48c8-8b9f-15db43e99d59.webp`,
                            url: 'https://www.immowelt.de/ratgeber/mieten/untervermietung-vertrag',
                            description: 'fsrbo.generic.edito.list.item1.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0c8f445c-f949-4533-bcef-bd714b73c2f5.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/vermietung-moebliert',
                            description: 'fsrbo.generic.edito.list.item2.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f48cbde-9790-4207-ae31-b980d55932f1.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-privat-verkaufen',
                            description: 'fsrbo.generic.edito.list.item3.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/176ba009-95f7-44fe-97d7-00805c20a98e.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/geerbtes-haus-verkaufen',
                            description: 'fsrbo.generic.edito.list.item4.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/ee95f773-fb23-451d-b8cc-41e6ad49a504.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/wertsteigerung-immobilien',
                            description: 'fsrbo.generic.edito.list.item5.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0f740b6b-74cf-424e-b2e7-0c2a60427307.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/nach-eigenbedarf-wieder-vermieten',
                            description: 'fsrbo.generic.edito.list.item6.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/661ef596-aae1-4f63-a756-8b95751dcf90.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/vermietete-wohnung-verkaufen',
                            description: 'fsrbo.generic.edito.list.item8.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/13ea3267-daa3-4c81-9086-7842d55596f8.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/expose-erstellen',
                            description: 'fsrbo.generic.edito.list.item9.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f4cdd17-71c6-4842-96c3-8ad5931d50bf.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-verkaufen-wohnrecht',
                            description: 'fsrbo.generic.edito.list.item10.text',
                            visible: true,
                        },
                    ],
                },
                contact: {
                    textLeft: false,
                    img: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/1e6fdba4-ae43-4668-8fed-2c3032960173.webp`,
                        tablet: `${process.env.STATIC_ASSETS_PATH}/images/585d1782-84f3-4e16-84d7-a485aa334b23.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.webp`,
                    },
                    cta: 'https://support.immowelt.de/hilfekontakt',
                    items: [
                        {
                            content: '+49 911 520 25-0',
                            icon: PhoneIcon,
                        },
                    ],
                },
                advertising: {
                    sections: [
                        {
                            id: 'rent',
                            title: 'frbo.flats.advertising.rent.title',
                            component: 'h2',
                            text: ['frbo.flats.advertising.rent.textpart1'],
                            feedback: (_jsx(Trans, { translation: "frbo.flats.advertising.rent.feedback", components: {
                                    strong: _jsx("strong", {}),
                                } })),
                        },
                        {
                            id: 'create',
                            title: 'frbo.flats.advertising.create.title',
                            content: [
                                {
                                    subtitle: '',
                                    text: ['frbo.flats.advertising.create.text1'],
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.create.subtitle1.title',
                                    text: [
                                        'frbo.flats.advertising.create.subtitle1.text1',
                                        'frbo.flats.advertising.create.subtitle1.text2',
                                        'frbo.flats.advertising.create.subtitle1.text3',
                                    ],
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.create.subtitle2.title',
                                    text: [
                                        'frbo.flats.advertising.create.subtitle2.text1',
                                        'frbo.flats.advertising.create.subtitle2.text2',
                                    ],
                                    list: [
                                        'frbo.flats.advertising.create.subtitle2.list.item1',
                                        'frbo.flats.advertising.create.subtitle2.list.item2',
                                        'frbo.flats.advertising.create.subtitle2.list.item3',
                                        'frbo.flats.advertising.create.subtitle2.list.item4',
                                        'frbo.flats.advertising.create.subtitle2.list.item5',
                                    ],
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.create.subtitle3.title',
                                    text: [
                                        'frbo.flats.advertising.create.subtitle3.text1',
                                        'frbo.flats.advertising.create.subtitle3.text2',
                                    ],
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.create.subtitle4.title',
                                    text: ['frbo.flats.advertising.create.subtitle4.text1'],
                                    feedback: (_jsx(Trans, { translation: "frbo.flats.advertising.create.subtitle4.feedback", components: {
                                            strong: _jsx("strong", {}),
                                            link: (_jsx(Link, { href: "/immobilienpreise", variant: "inline", children: "children" })),
                                        } })),
                                    textAfterFeedback: [
                                        'frbo.flats.advertising.create.subtitle4.textAfterFeedback1',
                                        'frbo.flats.advertising.create.subtitle4.textAfterFeedback2',
                                        'frbo.flats.advertising.create.subtitle4.textAfterFeedback3',
                                        'frbo.flats.advertising.create.subtitle4.textAfterFeedback4',
                                    ],
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.create.subtitle5.title',
                                    text: [
                                        'frbo.flats.advertising.create.subtitle5.text1',
                                        'frbo.flats.advertising.create.subtitle5.text2',
                                        'frbo.flats.advertising.create.subtitle5.text3',
                                    ],
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.create.subtitle6.title',
                                    text: [
                                        'frbo.flats.advertising.create.subtitle6.text1',
                                        'frbo.flats.advertising.create.subtitle6.text2',
                                    ],
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.create.subtitle7.title',
                                    text: [
                                        'frbo.flats.advertising.create.subtitle7.text1',
                                        'frbo.flats.advertising.create.subtitle7.text2',
                                    ],
                                    list: [
                                        'frbo.flats.advertising.create.subtitle7.list.item1',
                                        'frbo.flats.advertising.create.subtitle7.list.item2',
                                        'frbo.flats.advertising.create.subtitle7.list.item3',
                                    ],
                                    textAfterList: [
                                        'frbo.flats.advertising.create.subtitle7.textAfterList1',
                                    ],
                                },
                            ],
                            certificate: {
                                img: `${process.env.STATIC_ASSETS_PATH}/images/a57f6933-3f2e-444e-8641-b8306d7b4fb7.webp`,
                                title: 'fsrbo.flats.advertising.writing.certificate.title',
                                text: 'fsrbo.flats.advertising.writing.certificate.text',
                                cta: 'fsrbo.flats.advertising.writing.certificate.cta',
                            },
                        },
                        {
                            id: 'publish',
                            title: 'frbo.flats.advertising.publish.title',
                            text: ['frbo.flats.advertising.publish.text1'],
                            content: [
                                {
                                    subtitle: '',
                                    feedback: (_jsx(Trans, { translation: "frbo.flats.advertising.publish.feedback", components: {
                                            strong: _jsx("strong", {}),
                                        } })),
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.publish.subtitle1.title',
                                    orderedList: [
                                        {
                                            item: 'frbo.flats.advertising.publish.subtitle1.list.item1.title',
                                            description: [
                                                'frbo.flats.advertising.publish.subtitle1.list.item1.description1',
                                                'frbo.flats.advertising.publish.subtitle1.list.item1.description2',
                                            ],
                                        },
                                        {
                                            item: 'frbo.flats.advertising.publish.subtitle1.list.item2.title',
                                            description: [
                                                _jsx(Trans, { translation: "frbo.flats.advertising.publish.subtitle1.list.item2.description1", components: {
                                                        strong: _jsx("strong", {}),
                                                    } }),
                                                _jsx(Trans, { translation: "frbo.flats.advertising.publish.subtitle1.list.item2.description2", components: {
                                                        strong: _jsx("strong", {}),
                                                    } }),
                                            ],
                                        },
                                        {
                                            item: 'frbo.flats.advertising.publish.subtitle1.list.item3.title',
                                            description: [
                                                'frbo.flats.advertising.publish.subtitle1.list.item3.description1',
                                            ],
                                        },
                                        {
                                            item: 'frbo.flats.advertising.publish.subtitle1.list.item4.title',
                                            description: [
                                                'frbo.flats.advertising.publish.subtitle1.list.item4.description1',
                                                'frbo.flats.advertising.publish.subtitle1.list.item4.description2',
                                                'frbo.flats.advertising.publish.subtitle1.list.item4.description3',
                                            ],
                                        },
                                    ],
                                    feedback: (_jsx(Trans, { translation: "frbo.flats.advertising.publish.subtitle1.feedback", components: {
                                            strong: _jsx("strong", {}),
                                        } })),
                                },
                            ],
                        },
                        {
                            id: 'find',
                            title: 'frbo.flats.advertising.find.title',
                            content: [
                                {
                                    subtitle: '',
                                    text: [
                                        'frbo.flats.advertising.find.text1',
                                        'frbo.flats.advertising.find.text2',
                                    ],
                                    list: [
                                        'frbo.flats.advertising.find.list.item1',
                                        'frbo.flats.advertising.find.list.item2',
                                        'frbo.flats.advertising.find.list.item3',
                                        'frbo.flats.advertising.find.list.item4',
                                        'frbo.flats.advertising.find.list.item5',
                                    ],
                                    textAfterList: [
                                        'frbo.flats.advertising.find.textAfterList1',
                                        _jsx(Trans, { translation: "frbo.flats.advertising.find.textAfterList2", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        'frbo.flats.advertising.find.textAfterList3',
                                    ],
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.find.subtitle1.title',
                                    text: [
                                        'frbo.flats.advertising.find.subtitle1.text1',
                                        'frbo.flats.advertising.find.subtitle1.text2',
                                    ],
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.find.subtitle2.title',
                                    text: ['frbo.flats.advertising.find.subtitle2.text1'],
                                    subContent: [
                                        {
                                            subSubtitle: 'frbo.flats.advertising.find.subtitle2.subSubtitle1.title',
                                            text: [
                                                'frbo.flats.advertising.find.subtitle2.subSubtitle1.text1',
                                                'frbo.flats.advertising.find.subtitle2.subSubtitle1.text2',
                                            ],
                                        },
                                        {
                                            subSubtitle: 'frbo.flats.advertising.find.subtitle2.subSubtitle2.title',
                                            text: [
                                                _jsx(Trans, { translation: "frbo.flats.advertising.find.subtitle2.subSubtitle2.text1", components: {
                                                        strong: _jsx("strong", {}),
                                                    } }),
                                                _jsx(Trans, { translation: "frbo.flats.advertising.find.subtitle2.subSubtitle2.text2", components: {
                                                        strong: _jsx("strong", {}),
                                                    } }),
                                            ],
                                        },
                                        {
                                            subSubtitle: 'frbo.flats.advertising.find.subtitle3.title',
                                            text: ['frbo.flats.advertising.find.subtitle3.text1'],
                                        },
                                    ],
                                    list: [
                                        'frbo.flats.advertising.find.subtitle3.list.item1',
                                        'frbo.flats.advertising.find.subtitle3.list.item2',
                                    ],
                                    feedback: (_jsx(Trans, { translation: "frbo.flats.advertising.find.subtitle2.feedback", components: {
                                            strong: _jsx("strong", {}),
                                        } })),
                                },
                                {
                                    subtitle: 'frbo.flats.advertising.find.subtitle4.title',
                                    component: 'h3',
                                    text: ['frbo.flats.advertising.find.subtitle4.text1'],
                                    list: [
                                        'frbo.flats.advertising.find.subtitle4.list.item1',
                                        'frbo.flats.advertising.find.subtitle4.list.item2',
                                        'frbo.flats.advertising.find.subtitle4.list.item3',
                                        'frbo.flats.advertising.find.subtitle4.list.item4',
                                        'frbo.flats.advertising.find.subtitle4.list.item5',
                                        'frbo.flats.advertising.find.subtitle4.list.item6',
                                        'frbo.flats.advertising.find.subtitle4.list.item7',
                                    ],
                                    textAfterList: [
                                        'frbo.flats.advertising.find.subtitle4.textAfterList1',
                                    ],
                                    feedback: (_jsx(Trans, { translation: "frbo.flats.advertising.find.subtitle4.feedback", components: {
                                            strong: _jsx("strong", {}),
                                            link: (_jsx(Link, { href: "/ratgeber/mieten/wohnungsuebergabeprotokoll", variant: "inline", children: "children" })),
                                        } })),
                                },
                            ],
                        },
                    ],
                    cta: 'https://www.immowelt.de/anbieten/energieausweis?m=owner_page_sell_energy_certificate_order_energy_certificate',
                },
                linkBox,
            },
            houses: {
                popin: {
                    url: {
                        rent: '/eigentuemer/anzeigenerfassung/privatvermietung?propertyType=house',
                        sale: '',
                    },
                },
                breadcrumb: {
                    data: {
                        order: '0',
                        type: 'Breadcrumb',
                        name: 'dflp-houses-breadcrumb',
                        title: 'dflp-houses-breadcrumb',
                        slug: 'dflp-houses-breadcrumb',
                        links: [
                            {
                                url: '/',
                                label: 'immowelt',
                                title: 'immowelt',
                            },
                            {
                                url: '/anbieten',
                                label: 'Anbieten',
                                title: 'Anbieten',
                            },
                            {
                                url: '',
                                label: 'Haus-vermieten',
                                title: 'Haus-vermieten',
                            },
                        ],
                    },
                },
                hero: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/874dde32-393c-4568-a053-a386596f447a.webp`,
                    imgMobile: `${process.env.STATIC_ASSETS_PATH}/images/b1482286-e6ca-4b90-8c62-7a2d93e1f89f.webp`,
                    listItems: [
                        {
                            id: 'frbo.houses.hero.list.item1',
                            text: 'frbo.houses.hero.list.item1',
                        },
                        {
                            id: 'frbo.houses.hero.list.item2',
                            text: 'frbo.houses.hero.list.item2',
                        },
                        {
                            id: 'frbo.houses.hero.list.item3',
                            text: 'frbo.houses.hero.list.item3',
                        },
                    ],
                },
                valueProposition: [
                    {
                        title: 'frbo.houses.valueprop.list.item1.title',
                        text: 'frbo.houses.valueprop.list.item1.text',
                        id: 'known',
                    },
                    {
                        title: 'frbo.houses.valueprop.list.item2.title',
                        text: 'frbo.houses.valueprop.list.item2.text',
                        id: 'listings',
                    },
                    {
                        title: 'frbo.houses.valueprop.list.item3.title',
                        text: 'frbo.houses.valueprop.list.item3.text',
                        id: 'experience',
                    },
                ],
                callToAction: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6420fdaa-b8f7-4b49-8f56-3c1cef6878a9.svg`,
                },
                pricing: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6eb37fd3-fec4-4af6-9a40-a74766f7be5f.webp`,
                },
                offerSelection: {
                    isOfferSelectionDisplayed: true,
                    products: [
                        {
                            id: 'good',
                            name: 'offerCard.good.title',
                            description: 'offerCard.good.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/116ddba9-5ac7-4ea9-b6d9-862253abee9e.svg`,
                            iconAlt: 'offerCard.good.iconAlt',
                            featuresTitle: 'offerCard.good.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.good.features.item1',
                                },
                                {
                                    description: 'offerCard.good.features.item2',
                                },
                            ],
                        },
                        {
                            id: 'better',
                            name: 'offerCard.better.title',
                            description: 'offerCard.better.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/f91cf35f-00ba-42ad-8200-dcc7b11d2a33.svg`,
                            iconAlt: 'offerCard.better.iconAlt',
                            featuresTitle: 'offerCard.better.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.better.features.item1',
                                },
                                {
                                    description: 'offerCard.better.features.item2',
                                },
                            ],
                            isMostPopular: true,
                        },
                        {
                            id: 'best',
                            name: 'offerCard.best.title',
                            description: 'offerCard.best.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/523b043b-58f4-48a0-b9cf-76ca3b58a5bc.svg`,
                            iconAlt: 'offerCard.best.iconAlt',
                            featuresTitle: 'offerCard.best.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.best.features.item1',
                                },
                                {
                                    description: 'offerCard.best.features.item2',
                                },
                            ],
                        },
                    ],
                    offers: [
                        {
                            name: 'RENT',
                            label: 'offerCard.rent.label',
                            transactionType: 'RENT',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 0,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 34.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 54.99,
                                },
                            ],
                            default: true,
                        },
                        {
                            name: 'BUY',
                            label: 'offerCard.buy.label',
                            transactionType: 'BUY',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 59.99,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 84.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 139.99,
                                },
                            ],
                        },
                    ],
                },
                pushCards: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/451a3782-7530-4c27-a01e-fd235ffe9ce0.webp`,
                            url: '/immobilienpreise/deutschland',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0e810d8b-ba68-477b-824a-d8d92ae717d7.webp`,
                            url: '/erfassung/immobilien/index.aspx?atype=business#basics',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e924fb03-cdc7-45f2-9d15-a6f61b42955e.webp`,
                            url: '/immobilienbewertung',
                        },
                    ],
                },
                edito: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e89acf70-8c29-48c8-8b9f-15db43e99d59.webp`,
                            url: 'https://www.immowelt.de/ratgeber/mieten/untervermietung-vertrag',
                            description: 'fsrbo.generic.edito.list.item1.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0c8f445c-f949-4533-bcef-bd714b73c2f5.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/vermietung-moebliert',
                            description: 'fsrbo.generic.edito.list.item2.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f48cbde-9790-4207-ae31-b980d55932f1.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-privat-verkaufen',
                            description: 'fsrbo.generic.edito.list.item3.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/176ba009-95f7-44fe-97d7-00805c20a98e.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/geerbtes-haus-verkaufen',
                            description: 'fsrbo.generic.edito.list.item4.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/ee95f773-fb23-451d-b8cc-41e6ad49a504.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/wertsteigerung-immobilien',
                            description: 'fsrbo.generic.edito.list.item5.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0f740b6b-74cf-424e-b2e7-0c2a60427307.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/nach-eigenbedarf-wieder-vermieten',
                            description: 'fsrbo.generic.edito.list.item6.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/661ef596-aae1-4f63-a756-8b95751dcf90.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/vermietete-wohnung-verkaufen',
                            description: 'fsrbo.generic.edito.list.item8.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/13ea3267-daa3-4c81-9086-7842d55596f8.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/expose-erstellen',
                            description: 'fsrbo.generic.edito.list.item9.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f4cdd17-71c6-4842-96c3-8ad5931d50bf.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-verkaufen-wohnrecht',
                            description: 'fsrbo.generic.edito.list.item10.text',
                            visible: true,
                        },
                    ],
                },
                contact: {
                    textLeft: false,
                    img: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/1e6fdba4-ae43-4668-8fed-2c3032960173.webp`,
                        tablet: `${process.env.STATIC_ASSETS_PATH}/images/585d1782-84f3-4e16-84d7-a485aa334b23.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.webp`,
                    },
                    cta: 'https://support.immowelt.de/hilfekontakt',
                    items: [
                        {
                            content: '+49 911 520 25-0',
                            icon: PhoneIcon,
                        },
                    ],
                },
                advertising: {
                    sections: [
                        {
                            id: 'bloc1',
                            title: 'frbo.houses.advertising.rent.bloc1.title',
                            component: 'h2',
                            text: ['frbo.houses.advertising.rent.bloc1.textpart1'],
                            feedback: (_jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc1.feedback", components: {
                                    strong: _jsx("strong", {}),
                                    ul: _jsx("ul", {}),
                                    li: _jsx("li", {}),
                                } })),
                        },
                        {
                            id: 'bloc2',
                            title: 'frbo.houses.advertising.rent.bloc2.title',
                            text: ['frbo.houses.advertising.rent.bloc2.textpart1'],
                            component: 'h2',
                            content: [
                                {
                                    subtitle: 'frbo.houses.advertising.rent.bloc2.subtitle1.title',
                                    text: ['frbo.houses.advertising.rent.bloc2.subtitle1.text'],
                                    component: 'h3',
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc2.subtitle3.title',
                                    text: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc2.subtitle3.text", components: {
                                                strong: _jsx("strong", {}),
                                                ul: _jsx("ul", {}),
                                                li: _jsx("li", {}),
                                            } }),
                                    ],
                                    list: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc2.subtitle3.list.item1", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/mieten/mieterselbstauskunft", variant: "inline", children: "children" })),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc2.subtitle3.list.item2", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/mieten/mietschuldenfreiheitsbescheinigung", variant: "inline", children: "children" })),
                                                link2: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/mieter-weg-miete-futsch-was-tun-gegen-mietnomaden.html", variant: "inline", children: "children" })),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc2.subtitle3.list.item3", components: {
                                                link: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/bonitaetspruefung-auskunft-einholen-kreditwuerdigkeit-beweisen.html", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                                {
                                    component: 'p',
                                    subtitle: 'frbo.houses.advertising.rent.bloc2.subtitle2.title',
                                    list: [
                                        'frbo.houses.advertising.rent.bloc2.subtitle2.list.item1',
                                        'frbo.houses.advertising.rent.bloc2.subtitle2.list.item2',
                                        'frbo.houses.advertising.rent.bloc2.subtitle2.list.item3',
                                        'frbo.houses.advertising.rent.bloc2.subtitle2.list.item4',
                                        'frbo.houses.advertising.rent.bloc2.subtitle2.list.item5',
                                        'frbo.houses.advertising.rent.bloc2.subtitle2.list.item6',
                                        'frbo.houses.advertising.rent.bloc2.subtitle2.list.item7',
                                        'frbo.houses.advertising.rent.bloc2.subtitle2.list.item8',
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc2.subtitle2.list.item9", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/vermieten/grundriss-zeichnen", variant: "inline", children: "children" })),
                                            } }),
                                        'frbo.houses.advertising.rent.bloc2.subtitle2.list.item10',
                                    ],
                                },
                            ],
                            certificate: {
                                img: `${process.env.STATIC_ASSETS_PATH}/images/a57f6933-3f2e-444e-8641-b8306d7b4fb7.webp`,
                                title: 'frbo.houses.advertising.rent.bloc2.certificate.title',
                                text: 'frbo.houses.advertising.rent.bloc2.certificate.text',
                                cta: 'frbo.houses.advertising.rent.bloc2.certificate.cta',
                            },
                        },
                        {
                            id: 'bloc3',
                            title: 'frbo.houses.advertising.rent.bloc3.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc3.textpart1", components: {
                                        link: (_jsx(Link, { href: "/ratgeber/mieten/mietpreisbremse", variant: "inline", children: "children" })),
                                    } }),
                                _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc3.textpart2", components: {
                                        link: (_jsx(Link, { href: "/immobilienpreise/deutschland/wohnungspreise", variant: "inline", children: "children" })),
                                    } }),
                            ],
                            content: [
                                {
                                    component: 'p',
                                    subtitle: 'frbo.houses.advertising.rent.bloc3.subtitle.title',
                                    list: [
                                        'frbo.houses.advertising.rent.bloc3.subtitle.list.item1',
                                        'frbo.houses.advertising.rent.bloc3.subtitle.list.item2',
                                        'frbo.houses.advertising.rent.bloc3.subtitle.list.item3',
                                        'frbo.houses.advertising.rent.bloc3.subtitle.list.item4',
                                        'frbo.houses.advertising.rent.bloc3.subtitle.list.item5',
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc3.subtitle.list.item6", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/mieten/wohnflaechenberechnung", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                    textAfterList: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc3.textAfterList", components: {
                                                link: (_jsx(Link, { href: "/makler/suche", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                            ],
                        },
                        {
                            id: 'bloc4',
                            title: 'frbo.houses.advertising.rent.bloc4.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.textpart1", components: {
                                        link: (_jsx(Link, { href: "/ratgeber/vermieten/mietvertrag-vorlage", variant: "inline", children: "children" })),
                                    } }),
                            ],
                            content: [
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc4.subtitle1.title',
                                    text: ['frbo.houses.advertising.rent.bloc4.subtitle1.text'],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc4.subtitle2.title',
                                    text: ['frbo.houses.advertising.rent.bloc4.subtitle2.text'],
                                    list: [
                                        'frbo.houses.advertising.rent.bloc4.subtitle2.list1.item1',
                                        'frbo.houses.advertising.rent.bloc4.subtitle2.list1.item2',
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle2.list1.item3", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle2.list1.item4", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle2.list1.item5", components: {
                                                strong: _jsx("strong", {}),
                                                link: (_jsx(Link, { href: "/ratgeber/vermieten/betriebskostenpauschale", variant: "inline", children: "children" })),
                                            } }),
                                        'frbo.houses.advertising.rent.bloc4.subtitle2.list1.item6',
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle2.list1.item7", components: {
                                                strong: _jsx("strong", {}),
                                                link: (_jsx(Link, { href: "/ratgeber/wohnen/schneeraeumpflicht", variant: "inline", children: "children" })),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle2.list1.item8", components: {
                                                strong: _jsx("strong", {}),
                                                link: (_jsx(Link, { href: "/ratgeber/mieten/haustierhaltung", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc4.subtitle3.title',
                                    text: ['frbo.houses.advertising.rent.bloc4.subtitle3.text'],
                                    list: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle3.list1.item1", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        'frbo.houses.advertising.rent.bloc4.subtitle3.list1.item2',
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc4.subtitle4.title',
                                    text: ['frbo.houses.advertising.rent.bloc4.subtitle4.text'],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc4.subtitle5.title',
                                    text: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle5.text", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/mieten/wohnungsuebergabeprotokoll", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc4.subtitle6.title',
                                    list: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle6.list1.item1", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle6.list1.item2", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/vermieten/staffelmietvertrag", variant: "inline", children: "children" })),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle6.list1.item3", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/mieten/indexmietvertrag", variant: "inline", children: "children" })),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle6.list1.item4", components: {
                                                link: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/befristeter-mietvertrag-nur-mit-begruendung-moeglich.html", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc4.subtitle7.title',
                                    text: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle7.text", components: {
                                                link: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/befristeter-mietvertrag-nur-mit-begruendung-moeglich.html", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc4.subtitle8.title',
                                    text: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc4.subtitle8.text", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/vermieten/mietkaution-rueckzahlung", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                    list: [
                                        'frbo.houses.advertising.rent.bloc4.subtitle8.list1.item1',
                                        'frbo.houses.advertising.rent.bloc4.subtitle8.list1.item2',
                                        'frbo.houses.advertising.rent.bloc4.subtitle8.list1.item3',
                                        'frbo.houses.advertising.rent.bloc4.subtitle8.list1.item4',
                                    ],
                                },
                            ],
                        },
                        {
                            id: 'bloc5',
                            title: 'frbo.houses.advertising.rent.bloc5.title',
                            component: 'h2',
                            text: ['frbo.houses.advertising.rent.bloc5.text'],
                            content: [
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc5.subtitle1.title',
                                    list: [
                                        'frbo.houses.advertising.rent.bloc5.subtitle1.list1.item1',
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc5.subtitle1.list1.item2", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/wohnen/heizkostenverordnung", variant: "inline", children: "children" })),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc5.subtitle1.list1.item3", components: {
                                                link: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/schimmel-ursachen-erkennen-schaeden-beseitigen.html", variant: "inline", children: "children" })),
                                            } }),
                                        'frbo.houses.advertising.rent.bloc5.subtitle1.list1.item4',
                                        'frbo.houses.advertising.rent.bloc5.subtitle1.list1.item5',
                                        'frbo.houses.advertising.rent.bloc5.subtitle1.list1.item6',
                                    ],
                                    textAfterList: [
                                        'frbo.houses.advertising.rent.bloc5.subtitle1.list1.textafter',
                                    ],
                                },
                            ],
                        },
                        {
                            id: 'bloc6',
                            title: 'frbo.houses.advertising.rent.bloc6.title',
                            component: 'h2',
                            text: ['frbo.houses.advertising.rent.bloc6.text'],
                            content: [
                                {
                                    component: 'p',
                                    list: [
                                        'frbo.houses.advertising.rent.bloc6.list1.item1',
                                        'frbo.houses.advertising.rent.bloc6.list1.item2',
                                        'frbo.houses.advertising.rent.bloc6.list1.item3',
                                    ],
                                    textAfterList: [
                                        'frbo.houses.advertising.rent.bloc6.list1.textafter',
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc6.subtitle1.title',
                                    text: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc6.subtitle1.text", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/vermieten/mieteinnahmen-versteuern", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                            ],
                        },
                        {
                            id: 'bloc7',
                            title: 'frbo.houses.advertising.rent.bloc7.title',
                            component: 'h2',
                            text: [
                                'frbo.houses.advertising.rent.bloc7.text1',
                                _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc7.text2", components: {
                                        link: (_jsx(Link, { href: "/ratgeber/mieten/wohnungsuebergabeprotokoll", variant: "inline", children: "children" })),
                                    } }),
                            ],
                        },
                        {
                            id: 'bloc8',
                            title: 'frbo.houses.advertising.rent.bloc8.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc8.text", components: {
                                        link: (_jsx(Link, { href: "/ratgeber/mieten/gewerbliche-nutzung-wohnung", variant: "inline", children: "children" })),
                                    } }),
                            ],
                        },
                        {
                            id: 'bloc9',
                            title: 'frbo.houses.advertising.rent.bloc9.title',
                            component: 'h2',
                            text: ['frbo.houses.advertising.rent.bloc9.text'],
                        },
                        {
                            id: 'bloc10',
                            title: 'frbo.houses.advertising.rent.bloc10.title',
                            component: 'h2',
                            text: ['frbo.houses.advertising.rent.bloc10.text'],
                            content: [
                                {
                                    component: 'p',
                                    list: [
                                        'frbo.houses.advertising.rent.bloc10.list1.item1',
                                        'frbo.houses.advertising.rent.bloc10.list1.item2',
                                        'frbo.houses.advertising.rent.bloc10.list1.item3',
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc10.subtitle1.title',
                                    text: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc10.subtitle1.text", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                    ],
                                    list: [
                                        'frbo.houses.advertising.rent.bloc10.subtitle1.list1.item1',
                                        'frbo.houses.advertising.rent.bloc10.subtitle1.list1.item2',
                                        'frbo.houses.advertising.rent.bloc10.subtitle1.list1.item3',
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc10.subtitle2.title',
                                    list: [
                                        'frbo.houses.advertising.rent.bloc10.subtitle2.list1.item1',
                                        'frbo.houses.advertising.rent.bloc10.subtitle2.list1.item2',
                                        'frbo.houses.advertising.rent.bloc10.subtitle2.list1.item3',
                                        'frbo.houses.advertising.rent.bloc10.subtitle2.list1.item4',
                                        'frbo.houses.advertising.rent.bloc10.subtitle2.list1.item5',
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc10.subtitle3.title',
                                    text: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc10.subtitle3.text", components: {
                                                link: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/erbengemeinschaft.html", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc10.subtitle4.title',
                                    text: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc10.subtitle4.text1", components: {
                                                link: (_jsx(Link, { href: "/ratgeber/wohnen/zugewinnausgleich", variant: "inline", children: "children" })),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc10.subtitle4.text2", components: {
                                                link: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/spekulationssteuer-dann-wird-der-immobilienverkauf-teuer.html", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc10.subtitle5.title',
                                    text: ['frbo.houses.advertising.rent.bloc10.subtitle5.text'],
                                },
                            ],
                        },
                        {
                            id: 'bloc11',
                            title: 'frbo.houses.advertising.rent.bloc11.title',
                            component: 'h2',
                            text: ['frbo.houses.advertising.rent.bloc11.text'],
                            content: [
                                {
                                    component: 'h3',
                                    subtitle: 'frbo.houses.advertising.rent.bloc11.subtitle1.title',
                                    text: [
                                        _jsx(Trans, { translation: "frbo.houses.advertising.rent.bloc11.subtitle1.text", components: {
                                                link1: (_jsx(Link, { href: "/ratgeber/vermieten/maklerprovision-wer-zahlt", variant: "inline", children: "children" })),
                                                link2: (_jsx(Link, { href: "/makler/suche", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                            ],
                        },
                    ],
                    cta: 'https://www.immowelt.de/anbieten/energieausweis?m=owner_page_sell_energy_certificate_order_energy_certificate',
                },
                linkBox,
            },
            plots: {
                popin: {
                    url: {
                        rent: '/eigentuemer/anzeigenerfassung/privatvermietung?propertyType=plot',
                        sale: '',
                    },
                },
                breadcrumb: {
                    data: {
                        order: '0',
                        type: 'Breadcrumb',
                        name: 'dflp-plots-breadcrumb',
                        title: 'dflp-plots-breadcrumb',
                        slug: 'dflp-plots-breadcrumb',
                        links: [
                            {
                                url: '/',
                                label: 'immowelt',
                                title: 'immowelt',
                            },
                            {
                                url: '/anbieten',
                                label: 'Anbieten',
                                title: 'Anbieten',
                            },
                            {
                                url: '',
                                label: 'Grundstück verpachten',
                                title: 'Grundstück verpachten',
                            },
                        ],
                    },
                },
                hero: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/874dde32-393c-4568-a053-a386596f447a.webp`,
                    imgMobile: `${process.env.STATIC_ASSETS_PATH}/images/b1482286-e6ca-4b90-8c62-7a2d93e1f89f.webp`,
                    listItems: [
                        {
                            id: 'frbo.plots.hero.list.item1',
                            text: 'frbo.plots.hero.list.item1',
                        },
                        {
                            id: 'frbo.plots.hero.list.item2',
                            text: 'frbo.plots.hero.list.item2',
                        },
                        {
                            id: 'frbo.plots.hero.list.item3',
                            text: 'frbo.plots.hero.list.item3',
                        },
                    ],
                },
                valueProposition: [
                    {
                        title: 'frbo.plots.valueprop.list.item1.title',
                        text: 'frbo.plots.valueprop.list.item1.text',
                        id: 'known',
                    },
                    {
                        title: 'frbo.plots.valueprop.list.item2.title',
                        text: 'frbo.plots.valueprop.list.item2.text',
                        id: 'listings',
                    },
                    {
                        title: 'frbo.plots.valueprop.list.item3.title',
                        text: 'frbo.plots.valueprop.list.item3.text',
                        id: 'experience',
                    },
                ],
                callToAction: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6420fdaa-b8f7-4b49-8f56-3c1cef6878a9.svg`,
                },
                pricing: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6eb37fd3-fec4-4af6-9a40-a74766f7be5f.webp`,
                },
                offerSelection: {
                    isOfferSelectionDisplayed: true,
                    products: [
                        {
                            id: 'good',
                            name: 'offerCard.good.title',
                            description: 'offerCard.good.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/116ddba9-5ac7-4ea9-b6d9-862253abee9e.svg`,
                            iconAlt: 'offerCard.good.iconAlt',
                            featuresTitle: 'offerCard.good.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.good.features.item1',
                                },
                                {
                                    description: 'offerCard.good.features.item2',
                                },
                            ],
                        },
                        {
                            id: 'better',
                            name: 'offerCard.better.title',
                            description: 'offerCard.better.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/f91cf35f-00ba-42ad-8200-dcc7b11d2a33.svg`,
                            iconAlt: 'offerCard.better.iconAlt',
                            featuresTitle: 'offerCard.better.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.better.features.item1',
                                },
                                {
                                    description: 'offerCard.better.features.item2',
                                },
                            ],
                            isMostPopular: true,
                        },
                        {
                            id: 'best',
                            name: 'offerCard.best.title',
                            description: 'offerCard.best.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/523b043b-58f4-48a0-b9cf-76ca3b58a5bc.svg`,
                            iconAlt: 'offerCard.best.iconAlt',
                            featuresTitle: 'offerCard.best.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.best.features.item1',
                                },
                                {
                                    description: 'offerCard.best.features.item2',
                                },
                            ],
                        },
                    ],
                    offers: [
                        {
                            name: 'RENT',
                            label: 'offerCard.rent.label',
                            transactionType: 'RENT',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 0,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 34.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 54.99,
                                },
                            ],
                            default: true,
                        },
                        {
                            name: 'BUY',
                            label: 'offerCard.buy.label',
                            transactionType: 'BUY',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 59.99,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 84.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 139.99,
                                },
                            ],
                        },
                    ],
                },
                pushCards: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/451a3782-7530-4c27-a01e-fd235ffe9ce0.webp`,
                            url: '/immobilienpreise/deutschland',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0e810d8b-ba68-477b-824a-d8d92ae717d7.webp`,
                            url: '/erfassung/immobilien/index.aspx?atype=business#basics',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e924fb03-cdc7-45f2-9d15-a6f61b42955e.webp`,
                            url: '/immobilienbewertung',
                        },
                    ],
                },
                edito: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e89acf70-8c29-48c8-8b9f-15db43e99d59.webp`,
                            url: 'https://www.immowelt.de/ratgeber/mieten/untervermietung-vertrag',
                            description: 'fsrbo.generic.edito.list.item1.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0c8f445c-f949-4533-bcef-bd714b73c2f5.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/vermietung-moebliert',
                            description: 'fsrbo.generic.edito.list.item2.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f48cbde-9790-4207-ae31-b980d55932f1.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-privat-verkaufen',
                            description: 'fsrbo.generic.edito.list.item3.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/176ba009-95f7-44fe-97d7-00805c20a98e.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/geerbtes-haus-verkaufen',
                            description: 'fsrbo.generic.edito.list.item4.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/ee95f773-fb23-451d-b8cc-41e6ad49a504.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/wertsteigerung-immobilien',
                            description: 'fsrbo.generic.edito.list.item5.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0f740b6b-74cf-424e-b2e7-0c2a60427307.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/nach-eigenbedarf-wieder-vermieten',
                            description: 'fsrbo.generic.edito.list.item6.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/661ef596-aae1-4f63-a756-8b95751dcf90.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/vermietete-wohnung-verkaufen',
                            description: 'fsrbo.generic.edito.list.item8.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/13ea3267-daa3-4c81-9086-7842d55596f8.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/expose-erstellen',
                            description: 'fsrbo.generic.edito.list.item9.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f4cdd17-71c6-4842-96c3-8ad5931d50bf.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-verkaufen-wohnrecht',
                            description: 'fsrbo.generic.edito.list.item10.text',
                            visible: true,
                        },
                    ],
                },
                contact: {
                    textLeft: false,
                    img: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/1e6fdba4-ae43-4668-8fed-2c3032960173.webp`,
                        tablet: `${process.env.STATIC_ASSETS_PATH}/images/585d1782-84f3-4e16-84d7-a485aa334b23.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.webp`,
                    },
                    cta: 'https://support.immowelt.de/hilfekontakt',
                    items: [
                        {
                            content: '+49 911 520 25-0',
                            icon: PhoneIcon,
                        },
                    ],
                },
                advertising: {
                    sections: [
                        {
                            id: 'lease',
                            title: 'frbo.plots.advertising.lease.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "frbo.plots.advertising.lease.text1", components: {
                                        link: (_jsx(Link, { href: "https://www.immowelt.de/suche/grundstuecke/kaufen/", variant: "inline", children: "children" })),
                                    } }),
                            ],
                        },
                        {
                            id: 'difference',
                            title: 'frbo.plots.advertising.difference.title',
                            component: 'h3',
                            text: ['frbo.plots.advertising.difference.text1'],
                        },
                        {
                            id: 'tenant',
                            title: 'frbo.plots.advertising.tenant.title',
                            component: 'h3',
                            text: ['frbo.plots.advertising.tenant.text1'],
                        },
                        {
                            id: 'determine',
                            title: 'frbo.plots.advertising.determine.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "frbo.plots.advertising.determine.text1", components: {
                                        ul: _jsx("ul", {}),
                                        li: _jsx("li", {}),
                                    } }),
                            ],
                        },
                        {
                            id: 'agreement',
                            title: 'frbo.plots.advertising.agreement.title',
                            component: 'h2',
                            text: ['frbo.plots.advertising.agreement.text1'],
                        },
                    ],
                },
                linkBox,
            },
            commercial: {
                popin: {
                    url: {
                        sale: '',
                        rent: '/eigentuemer/anzeigenerfassung/privatvermietung?propertyType=office',
                    },
                },
                breadcrumb: {
                    data: {
                        order: '0',
                        type: 'Breadcrumb',
                        name: 'dflp-commercial-breadcrumb',
                        title: 'dflp-commercial-breadcrumb',
                        slug: 'dflp-commercial-breadcrumb',
                        links: [
                            {
                                url: '/',
                                label: 'immowelt',
                                title: 'immowelt',
                            },
                            {
                                url: '/anbieten',
                                label: 'Anbieten',
                                title: 'Anbieten',
                            },
                            {
                                url: '',
                                label: 'Büro vermieten',
                                title: 'Büro vermieten',
                            },
                        ],
                    },
                },
                hero: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/874dde32-393c-4568-a053-a386596f447a.webp`,
                    imgMobile: `${process.env.STATIC_ASSETS_PATH}/images/b1482286-e6ca-4b90-8c62-7a2d93e1f89f.webp`,
                    listItems: [
                        {
                            id: 'frbo.generic.hero.list.item1',
                            text: 'frbo.generic.hero.list.item1',
                        },
                        {
                            id: 'frbo.generic.hero.list.item2',
                            text: 'frbo.generic.hero.list.item2',
                        },
                        {
                            id: 'frbo.generic.hero.list.item3',
                            text: 'frbo.generic.hero.list.item3',
                        },
                    ],
                },
                valueProposition: [
                    {
                        title: 'fsrbo.generic.valueprop.list.item1.title',
                        text: 'fsrbo.generic.valueprop.list.item1.text',
                        id: 'known',
                    },
                    {
                        title: 'fsrbo.generic.valueprop.list.item2.title',
                        text: 'fsrbo.generic.valueprop.list.item2.text',
                        id: 'listings',
                    },
                    {
                        title: 'fsrbo.generic.valueprop.list.item3.title',
                        text: 'fsrbo.generic.valueprop.list.item3.text',
                        id: 'experience',
                    },
                ],
                callToAction: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6420fdaa-b8f7-4b49-8f56-3c1cef6878a9.svg`,
                },
                pricing: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6eb37fd3-fec4-4af6-9a40-a74766f7be5f.webp`,
                },
                offerSelection: {
                    isOfferSelectionDisplayed: true,
                    products: [
                        {
                            id: 'good',
                            name: 'offerCard.good.title',
                            description: 'offerCard.good.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/116ddba9-5ac7-4ea9-b6d9-862253abee9e.svg`,
                            iconAlt: 'offerCard.good.iconAlt',
                            featuresTitle: 'offerCard.good.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.good.features.item1',
                                },
                                {
                                    description: 'offerCard.good.features.item2',
                                },
                            ],
                        },
                        {
                            id: 'better',
                            name: 'offerCard.better.title',
                            description: 'offerCard.better.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/f91cf35f-00ba-42ad-8200-dcc7b11d2a33.svg`,
                            iconAlt: 'offerCard.better.iconAlt',
                            featuresTitle: 'offerCard.better.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.better.features.item1',
                                },
                                {
                                    description: 'offerCard.better.features.item2',
                                },
                            ],
                            isMostPopular: true,
                        },
                        {
                            id: 'best',
                            name: 'offerCard.best.title',
                            description: 'offerCard.best.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/523b043b-58f4-48a0-b9cf-76ca3b58a5bc.svg`,
                            iconAlt: 'offerCard.best.iconAlt',
                            featuresTitle: 'offerCard.best.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.best.features.item1',
                                },
                                {
                                    description: 'offerCard.best.features.item2',
                                },
                            ],
                        },
                    ],
                    offers: [
                        {
                            name: 'RENT',
                            label: 'offerCard.rent.label',
                            transactionType: 'RENT',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 0,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 34.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 54.99,
                                },
                            ],
                            default: true,
                        },
                        {
                            name: 'BUY',
                            label: 'offerCard.buy.label',
                            transactionType: 'BUY',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 59.99,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 84.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 139.99,
                                },
                            ],
                        },
                    ],
                },
                pushCards: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/451a3782-7530-4c27-a01e-fd235ffe9ce0.webp`,
                            url: '/immobilienpreise/deutschland',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0e810d8b-ba68-477b-824a-d8d92ae717d7.webp`,
                            url: 'https://signin.immowelt.de/?path=%2Fdispatcher%2Findex.html%3Fm%3Dclassified_deposit_project_project_list_your_dedicated_service_general_caf_step_1&m=classified_deposit_landing_access_the_service_general_caf_step_1 ',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e924fb03-cdc7-45f2-9d15-a6f61b42955e.webp`,
                            url: '/immobilienbewertung',
                        },
                    ],
                },
                edito: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e89acf70-8c29-48c8-8b9f-15db43e99d59.webp`,
                            url: 'https://www.immowelt.de/ratgeber/mieten/untervermietung-vertrag',
                            description: 'fsrbo.generic.edito.list.item1.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0c8f445c-f949-4533-bcef-bd714b73c2f5.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/vermietung-moebliert',
                            description: 'fsrbo.generic.edito.list.item2.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f48cbde-9790-4207-ae31-b980d55932f1.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-privat-verkaufen',
                            description: 'fsrbo.generic.edito.list.item3.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/176ba009-95f7-44fe-97d7-00805c20a98e.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/geerbtes-haus-verkaufen',
                            description: 'fsrbo.generic.edito.list.item4.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/ee95f773-fb23-451d-b8cc-41e6ad49a504.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/wertsteigerung-immobilien',
                            description: 'fsrbo.generic.edito.list.item5.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0f740b6b-74cf-424e-b2e7-0c2a60427307.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/nach-eigenbedarf-wieder-vermieten',
                            description: 'fsrbo.generic.edito.list.item6.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/661ef596-aae1-4f63-a756-8b95751dcf90.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/vermietete-wohnung-verkaufen',
                            description: 'fsrbo.generic.edito.list.item8.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/13ea3267-daa3-4c81-9086-7842d55596f8.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/expose-erstellen',
                            description: 'fsrbo.generic.edito.list.item9.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f4cdd17-71c6-4842-96c3-8ad5931d50bf.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-verkaufen-wohnrecht',
                            description: 'fsrbo.generic.edito.list.item10.text',
                            visible: true,
                        },
                    ],
                },
                advertising: {
                    sections: [
                        {
                            id: 'tips',
                            title: 'frbo.commercial.advertising.tips.title',
                            text: ['frbo.commercial.advertising.tips.text'],
                        },
                        {
                            id: 'types',
                            title: 'frbo.commercial.advertising.types.title',
                            text: ['frbo.commercial.advertising.types.text'],
                            content: [
                                {
                                    list: [
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.types.list.part1", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.types.list.part2", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.types.list.part3", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.types.list.part4", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.types.list.part5", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.types.list.part6", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                    ],
                                    textAfterList: [
                                        'frbo.commercial.advertising.types.afterList',
                                    ],
                                },
                            ],
                        },
                        {
                            id: 'lease',
                            title: 'frbo.commercial.advertising.lease.title',
                            text: [
                                _jsx(Trans, { translation: "frbo.commercial.advertising.lease.text", components: {
                                        link: (_jsx(Link, { href: "/anbieten/gewerbeimmobilien", variant: "inline", children: "children" })),
                                    } }),
                            ],
                            content: [
                                {
                                    list: [
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.lease.list.part1", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.lease.list.part2", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.lease.list.part3", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.lease.list.part4", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.lease.list.part5", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                    ],
                                    textAfterList: [
                                        _jsx(Trans, { translation: "frbo.commercial.advertising.lease.afterList", components: {
                                                link: (_jsx(Link, { href: "/anbieten/gewerbe/anzeigenpakete", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                            ],
                        },
                    ],
                },
                contact: {
                    textLeft: false,
                    img: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/1e6fdba4-ae43-4668-8fed-2c3032960173.webp`,
                        tablet: `${process.env.STATIC_ASSETS_PATH}/images/585d1782-84f3-4e16-84d7-a485aa334b23.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.webp`,
                    },
                    cta: 'https://support.immowelt.de/hilfekontakt',
                    items: [
                        {
                            content: '+49 911 520 25-0',
                            icon: PhoneIcon,
                        },
                    ],
                },
                linkBox,
            },
        },
        fsbo: {
            generic: {
                popin: {
                    url: {
                        rent: '',
                        sale: '/eigentuemer/anzeigenerfassung/privatverkauf',
                    },
                },
                breadcrumb: {
                    data: {
                        order: '0',
                        type: 'Breadcrumb',
                        name: 'dflp-generic-breadcrumb',
                        title: 'dflp-generic-breadcrumb',
                        slug: 'dflp-generic-breadcrumb',
                        links: [
                            {
                                url: '/',
                                label: 'immowelt',
                                title: 'immowelt',
                            },
                            {
                                url: '/anbieten',
                                label: 'Anbieten',
                                title: 'Anbieten',
                            },
                            {
                                url: '',
                                label: 'Immobilie verkaufen',
                                title: 'Immobilie verkaufen',
                            },
                        ],
                    },
                },
                hero: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/874dde32-393c-4568-a053-a386596f447a.webp`,
                    imgMobile: `${process.env.STATIC_ASSETS_PATH}/images/b1482286-e6ca-4b90-8c62-7a2d93e1f89f.webp`,
                    listItems: [
                        {
                            id: 'fsbo.generic.hero.list.item1',
                            text: 'fsbo.generic.hero.list.item1',
                        },
                        {
                            id: 'fsbo.generic.hero.list.item2',
                            text: 'fsbo.generic.hero.list.item2',
                        },
                        {
                            id: 'fsbo.generic.hero.list.item3',
                            text: 'fsbo.generic.hero.list.item3',
                        },
                    ],
                },
                valueProposition: [
                    {
                        title: 'fsbo.generic.valueprop.list.item1.title',
                        text: 'fsbo.generic.valueprop.list.item1.text',
                        id: 'known',
                    },
                    {
                        title: 'fsbo.generic.valueprop.list.item2.title',
                        text: 'fsbo.generic.valueprop.list.item2.text',
                        id: 'listings',
                    },
                    {
                        title: 'fsbo.generic.valueprop.list.item3.title',
                        text: 'fsbo.generic.valueprop.list.item3.text',
                        id: 'experience',
                    },
                ],
                callToAction: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6420fdaa-b8f7-4b49-8f56-3c1cef6878a9.svg`,
                },
                pricing: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6eb37fd3-fec4-4af6-9a40-a74766f7be5f.webp`,
                },
                offerSelection: {
                    isOfferSelectionDisplayed: true,
                    products: [
                        {
                            id: 'good',
                            name: 'offerCard.good.title',
                            description: 'offerCard.good.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/116ddba9-5ac7-4ea9-b6d9-862253abee9e.svg`,
                            iconAlt: 'offerCard.good.iconAlt',
                            featuresTitle: 'offerCard.good.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.good.features.item1',
                                },
                                {
                                    description: 'offerCard.good.features.item2',
                                },
                            ],
                        },
                        {
                            id: 'better',
                            name: 'offerCard.better.title',
                            description: 'offerCard.better.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/f91cf35f-00ba-42ad-8200-dcc7b11d2a33.svg`,
                            iconAlt: 'offerCard.better.iconAlt',
                            featuresTitle: 'offerCard.better.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.better.features.item1',
                                },
                                {
                                    description: 'offerCard.better.features.item2',
                                },
                            ],
                            isMostPopular: true,
                        },
                        {
                            id: 'best',
                            name: 'offerCard.best.title',
                            description: 'offerCard.best.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/523b043b-58f4-48a0-b9cf-76ca3b58a5bc.svg`,
                            iconAlt: 'offerCard.best.iconAlt',
                            featuresTitle: 'offerCard.best.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.best.features.item1',
                                },
                                {
                                    description: 'offerCard.best.features.item2',
                                },
                            ],
                        },
                    ],
                    offers: [
                        {
                            name: 'RENT',
                            label: 'offerCard.rent.label',
                            transactionType: 'RENT',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 0,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 34.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 54.99,
                                },
                            ],
                        },
                        {
                            name: 'BUY',
                            label: 'offerCard.buy.label',
                            transactionType: 'BUY',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 59.99,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 84.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 139.99,
                                },
                            ],
                            default: true,
                        },
                    ],
                },
                pushCards: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/451a3782-7530-4c27-a01e-fd235ffe9ce0.webp`,
                            url: '/immobilienpreise/deutschland',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0e810d8b-ba68-477b-824a-d8d92ae717d7.webp`,
                            url: '/erfassung/immobilien/index.aspx?atype=business#basics',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e924fb03-cdc7-45f2-9d15-a6f61b42955e.webp`,
                            url: '/immobilienbewertung',
                        },
                    ],
                },
                edito: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e89acf70-8c29-48c8-8b9f-15db43e99d59.webp`,
                            url: 'https://www.immowelt.de/ratgeber/mieten/untervermietung-vertrag',
                            description: 'fsrbo.generic.edito.list.item1.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0c8f445c-f949-4533-bcef-bd714b73c2f5.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/vermietung-moebliert',
                            description: 'fsrbo.generic.edito.list.item2.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f48cbde-9790-4207-ae31-b980d55932f1.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-privat-verkaufen',
                            description: 'fsrbo.generic.edito.list.item3.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/176ba009-95f7-44fe-97d7-00805c20a98e.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/geerbtes-haus-verkaufen',
                            description: 'fsrbo.generic.edito.list.item4.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/ee95f773-fb23-451d-b8cc-41e6ad49a504.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/wertsteigerung-immobilien',
                            description: 'fsrbo.generic.edito.list.item5.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0f740b6b-74cf-424e-b2e7-0c2a60427307.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/nach-eigenbedarf-wieder-vermieten',
                            description: 'fsrbo.generic.edito.list.item6.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/661ef596-aae1-4f63-a756-8b95751dcf90.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/vermietete-wohnung-verkaufen',
                            description: 'fsrbo.generic.edito.list.item8.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/13ea3267-daa3-4c81-9086-7842d55596f8.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/expose-erstellen',
                            description: 'fsrbo.generic.edito.list.item9.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f4cdd17-71c6-4842-96c3-8ad5931d50bf.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-verkaufen-wohnrecht',
                            description: 'fsrbo.generic.edito.list.item10.text',
                            visible: true,
                        },
                    ],
                },
                contact: {
                    textLeft: false,
                    img: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/1e6fdba4-ae43-4668-8fed-2c3032960173.webp`,
                        tablet: `${process.env.STATIC_ASSETS_PATH}/images/585d1782-84f3-4e16-84d7-a485aa334b23.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.webp`,
                    },
                    cta: 'https://support.immowelt.de/hilfekontakt',
                    items: [
                        {
                            content: '+49 911 520 25-0',
                            icon: PhoneIcon,
                        },
                    ],
                },
                advertising: {
                    sections: [
                        {
                            id: 'selling',
                            title: 'fsbo.generic.advertising.selling.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "fsbo.generic.advertising.selling.text1", components: {
                                        strong: _jsx("strong", {}),
                                        ul: _jsx("ul", {}),
                                        li: _jsx("li", {}),
                                    } }),
                            ],
                        },
                        {
                            id: 'estate',
                            title: 'fsbo.generic.advertising.estate.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "fsbo.generic.advertising.estate.text1", components: {
                                        link: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/geteilte-maklerprovision-leitfaden-fuer-neue-vertraege", variant: "inline", children: "children" })),
                                        ul: _jsx("ul", {}),
                                        li: _jsx("li", {}),
                                    } }),
                            ],
                        },
                        {
                            id: 'create',
                            title: 'fsbo.generic.advertising.create.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "fsbo.generic.advertising.create.text1", components: {
                                        link: (_jsx(Link, { href: "/", variant: "inline", children: "children" })),
                                    } }),
                            ],
                            content: [
                                {
                                    subtitle: 'fsbo.generic.advertising.create.content1.title',
                                    component: 'h3',
                                    text: [
                                        _jsx(Trans, { translation: "fsbo.generic.advertising.create.content1.text", components: {
                                                strong: _jsx("strong", {}),
                                            } }),
                                    ],
                                },
                                {
                                    subtitle: 'fsbo.generic.advertising.create.content2.title',
                                    component: 'h3',
                                    text: ['fsbo.generic.advertising.create.content2.text'],
                                },
                                {
                                    subtitle: 'fsbo.generic.advertising.create.content3.title',
                                    component: 'h3',
                                    text: [
                                        _jsx(Trans, { translation: "fsbo.generic.advertising.create.content3.text", components: {
                                                link1: (_jsx(Link, { href: "https://www.immowelt.de/immobilienpreise", variant: "inline", children: "children" })),
                                                link2: (_jsx(Link, { href: "https://www.immowelt.de/anbieten/immobilienbewertung", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                                {
                                    subtitle: 'fsbo.generic.advertising.create.content4.title',
                                    component: 'h3',
                                    text: [
                                        _jsx(Trans, { translation: "fsbo.generic.advertising.create.content4.text", components: {
                                                link: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/grundriss-zeichnen", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                                {
                                    subtitle: 'fsbo.generic.advertising.create.content5.title',
                                    component: 'h3',
                                    text: [
                                        _jsx(Trans, { translation: "fsbo.generic.advertising.create.content5.text", components: {
                                                link: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/verbrauchsausweis-oder-bedarfsausweis-welcher-der-richtige-ist", variant: "inline", children: "children" })),
                                            } }),
                                    ],
                                },
                            ],
                            certificate: {
                                img: `${process.env.STATIC_ASSETS_PATH}/images/a57f6933-3f2e-444e-8641-b8306d7b4fb7.webp`,
                                title: 'fsbo.generic.advertising.create.certificate.title',
                                text: 'fsbo.generic.advertising.create.certificate.text',
                                cta: 'fsbo.generic.advertising.create.certificate.cta',
                            },
                            endText: [
                                _jsx(Trans, { translation: "fsbo.generic.advertising.create.endText", components: {
                                        link: (_jsx(Link, { href: "https://www.immowelt.de/makler", variant: "inline", children: "children" })),
                                    } }),
                            ],
                        },
                        {
                            id: 'publish',
                            title: 'fsbo.generic.advertising.publish.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "fsbo.generic.advertising.publish.text", components: {
                                        strong: _jsx("strong", {}),
                                        link1: (_jsx(Link, { href: "https://www.immowelt.de/anbieten/haus-schaetzen-lassen", variant: "inline", children: "children" })),
                                        link2: (_jsx(Link, { href: "/", variant: "inline", children: "children" })),
                                    } }),
                            ],
                        },
                        {
                            id: 'buyers',
                            title: 'fsbo.generic.advertising.buyers.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "fsbo.generic.advertising.buyers.text", components: {
                                        strong: _jsx("strong", {}),
                                        link: (_jsx(Link, { href: "https://ratgeber.immowelt.de/a/hausuebergabeprotokoll-sicher-ins-eigenheim", variant: "inline", children: "children" })),
                                    } }),
                            ],
                        },
                    ],
                },
                linkBox,
            },
            plots: {
                popin: {
                    url: {
                        rent: '',
                        sale: '/eigentuemer/anzeigenerfassung/privatverkauf?propertyType=plot',
                    },
                },
                breadcrumb: {
                    data: {
                        order: '0',
                        type: 'Breadcrumb',
                        name: 'dflp-plots-breadcrumb',
                        title: 'dflp-plots-breadcrumb',
                        slug: 'dflp-plots-breadcrumb',
                        links: [
                            {
                                url: '/',
                                label: 'immowelt',
                                title: 'immowelt',
                            },
                            {
                                url: '/anbieten',
                                label: 'Anbieten',
                                title: 'Anbieten',
                            },
                            {
                                url: '',
                                label: 'Grundstück-verkaufen',
                                title: 'Grundstück-verkaufen',
                            },
                        ],
                    },
                },
                hero: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/874dde32-393c-4568-a053-a386596f447a.webp`,
                    imgMobile: `${process.env.STATIC_ASSETS_PATH}/images/b1482286-e6ca-4b90-8c62-7a2d93e1f89f.webp`,
                    listItems: [
                        {
                            id: 'fsbo.plots.hero.list.item1',
                            text: 'fsbo.plots.hero.list.item1',
                        },
                        {
                            id: 'fsbo.plots.hero.list.item2',
                            text: 'fsbo.plots.hero.list.item2',
                        },
                        {
                            id: 'fsbo.plots.hero.list.item3',
                            text: 'fsbo.plots.hero.list.item3',
                        },
                    ],
                },
                valueProposition: [
                    {
                        title: 'fsbo.plots.valueprop.list.item1.title',
                        text: 'fsbo.plots.valueprop.list.item1.text',
                        id: 'known',
                    },
                    {
                        title: 'fsbo.plots.valueprop.list.item2.title',
                        text: 'fsbo.plots.valueprop.list.item2.text',
                        id: 'listings',
                    },
                    {
                        title: 'fsbo.plots.valueprop.list.item3.title',
                        text: 'fsbo.plots.valueprop.list.item3.text',
                        id: 'experience',
                    },
                ],
                callToAction: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6420fdaa-b8f7-4b49-8f56-3c1cef6878a9.svg`,
                },
                pricing: {
                    img: `${process.env.STATIC_ASSETS_PATH}/images/6eb37fd3-fec4-4af6-9a40-a74766f7be5f.webp`,
                },
                offerSelection: {
                    isOfferSelectionDisplayed: true,
                    products: [
                        {
                            id: 'good',
                            name: 'offerCard.good.title',
                            description: 'offerCard.good.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/116ddba9-5ac7-4ea9-b6d9-862253abee9e.svg`,
                            iconAlt: 'offerCard.good.iconAlt',
                            featuresTitle: 'offerCard.good.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.good.features.item1',
                                },
                                {
                                    description: 'offerCard.good.features.item2',
                                },
                            ],
                        },
                        {
                            id: 'better',
                            name: 'offerCard.better.title',
                            description: 'offerCard.better.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/f91cf35f-00ba-42ad-8200-dcc7b11d2a33.svg`,
                            iconAlt: 'offerCard.better.iconAlt',
                            featuresTitle: 'offerCard.better.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.better.features.item1',
                                },
                                {
                                    description: 'offerCard.better.features.item2',
                                },
                            ],
                            isMostPopular: true,
                        },
                        {
                            id: 'best',
                            name: 'offerCard.best.title',
                            description: 'offerCard.best.description',
                            iconPath: `${process.env.STATIC_ASSETS_PATH}/images/523b043b-58f4-48a0-b9cf-76ca3b58a5bc.svg`,
                            iconAlt: 'offerCard.best.iconAlt',
                            featuresTitle: 'offerCard.best.featuresTitle',
                            features: [
                                {
                                    description: 'offerCard.best.features.item1',
                                },
                                {
                                    description: 'offerCard.best.features.item2',
                                },
                            ],
                        },
                    ],
                    offers: [
                        {
                            name: 'RENT',
                            label: 'offerCard.rent.label',
                            transactionType: 'RENT',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 0,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 34.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 54.99,
                                },
                            ],
                        },
                        {
                            name: 'BUY',
                            label: 'offerCard.buy.label',
                            transactionType: 'BUY',
                            prices: [
                                {
                                    productId: 'good',
                                    currency: 'EUR',
                                    regularPrice: 59.99,
                                },
                                {
                                    productId: 'better',
                                    currency: 'EUR',
                                    regularPrice: 84.99,
                                },
                                {
                                    productId: 'best',
                                    currency: 'EUR',
                                    regularPrice: 139.99,
                                },
                            ],
                            default: true,
                        },
                    ],
                },
                pushCards: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/451a3782-7530-4c27-a01e-fd235ffe9ce0.webp`,
                            url: '/immobilienpreise/deutschland',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0e810d8b-ba68-477b-824a-d8d92ae717d7.webp`,
                            url: '/erfassung/immobilien/index.aspx?atype=business#basics',
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e924fb03-cdc7-45f2-9d15-a6f61b42955e.webp`,
                            url: '/immobilienbewertung',
                        },
                    ],
                },
                edito: {
                    items: [
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/e89acf70-8c29-48c8-8b9f-15db43e99d59.webp`,
                            url: 'https://www.immowelt.de/ratgeber/mieten/untervermietung-vertrag',
                            description: 'fsrbo.generic.edito.list.item1.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0c8f445c-f949-4533-bcef-bd714b73c2f5.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/vermietung-moebliert',
                            description: 'fsrbo.generic.edito.list.item2.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f48cbde-9790-4207-ae31-b980d55932f1.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-privat-verkaufen',
                            description: 'fsrbo.generic.edito.list.item3.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/176ba009-95f7-44fe-97d7-00805c20a98e.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/geerbtes-haus-verkaufen',
                            description: 'fsrbo.generic.edito.list.item4.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/ee95f773-fb23-451d-b8cc-41e6ad49a504.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/wertsteigerung-immobilien',
                            description: 'fsrbo.generic.edito.list.item5.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/0f740b6b-74cf-424e-b2e7-0c2a60427307.webp`,
                            url: 'https://www.immowelt.de/ratgeber/vermieten/nach-eigenbedarf-wieder-vermieten',
                            description: 'fsrbo.generic.edito.list.item6.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/661ef596-aae1-4f63-a756-8b95751dcf90.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/vermietete-wohnung-verkaufen',
                            description: 'fsrbo.generic.edito.list.item8.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/13ea3267-daa3-4c81-9086-7842d55596f8.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/expose-erstellen',
                            description: 'fsrbo.generic.edito.list.item9.text',
                            visible: true,
                        },
                        {
                            img: `${process.env.STATIC_ASSETS_PATH}/images/9f4cdd17-71c6-4842-96c3-8ad5931d50bf.webp`,
                            url: 'https://www.immowelt.de/ratgeber/verkaufen/haus-verkaufen-wohnrecht',
                            description: 'fsrbo.generic.edito.list.item10.text',
                            visible: true,
                        },
                    ],
                },
                contact: {
                    textLeft: false,
                    img: {
                        desktop: `${process.env.STATIC_ASSETS_PATH}/images/1e6fdba4-ae43-4668-8fed-2c3032960173.webp`,
                        tablet: `${process.env.STATIC_ASSETS_PATH}/images/585d1782-84f3-4e16-84d7-a485aa334b23.webp`,
                        mobile: `${process.env.STATIC_ASSETS_PATH}/images/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.webp`,
                    },
                    cta: 'https://support.immowelt.de/hilfekontakt',
                    items: [
                        {
                            content: '+49 911 520 25-0',
                            icon: PhoneIcon,
                        },
                    ],
                },
                advertising: {
                    sections: [
                        {
                            id: 'selling',
                            title: 'fsbo.plots.advertising.selling.title',
                            component: 'h2',
                            text: ['fsbo.plots.advertising.selling.text1'],
                        },
                        {
                            id: 'building',
                            title: 'fsbo.plots.advertising.building.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "fsbo.plots.advertising.building.text1", components: {
                                        strong: _jsx("strong", {}),
                                    } }),
                            ],
                        },
                        {
                            id: 'determine',
                            title: 'fsbo.plots.advertising.determine.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "fsbo.plots.advertising.determine.text1", components: {
                                        strong: _jsx("strong", {}),
                                    } }),
                            ],
                        },
                        {
                            id: 'finding',
                            title: 'fsbo.plots.advertising.finding.title',
                            component: 'h2',
                            text: [
                                _jsx(Trans, { translation: "fsbo.plots.advertising.finding.text1", components: {
                                        strong: _jsx("strong", {}),
                                        link: (_jsx(Link, { href: "/", variant: "inline", children: "children" })),
                                    } }),
                            ],
                            content: [
                                {
                                    list: [
                                        'fsbo.plots.advertising.finding.list.item1',
                                        'fsbo.plots.advertising.finding.list.item2',
                                        'fsbo.plots.advertising.finding.list.item3',
                                        'fsbo.plots.advertising.finding.list.item4',
                                        'fsbo.plots.advertising.finding.list.item5',
                                        'fsbo.plots.advertising.finding.list.item6',
                                    ],
                                    textAfterList: [
                                        'fsbo.plots.advertising.finding.textAfterList1',
                                    ],
                                },
                            ],
                        },
                    ],
                },
                linkBox,
            },
        },
    },
});
